{
  "common": {
    "appTitle": "Draughts MVP",
    "back": "Terug",
    "exit": "Afsluiten",
    "cancel": "Annuleren",
    "close": "Sluiten",
    "continue": "Doorgaan",
    "copy": "Kopiëren",
    "error": "Fout",
    "loading": "Laden...",
    "retry": "Opnieuw proberen",
    "or": "of",
    "vs": "vs",
    "you": "Jij",
    "anonymous": "Anoniem",
    "send": "Versturen",
    "download": "Downloaden",
    "noLimit": "Geen limiet",
    "comingSoon": "Binnenkort",
    "version": "v{{version}}",
    "enabled": "Ingeschakeld",
    "disabled": "Uitgeschakeld",
    "apply": "Toepassen",
    "errorBoundary": "Er is iets misgegaan. Probeer te herladen: als er net een nieuwe versie is, wordt die opgehaald.",
    "dismissNotice": "Sluiten"
  },
  "errors": {
    "loadFailed": "Deze gegevens konden niet worden geladen. Probeer het opnieuw.",
    "network": "Geen internetverbinding. Controleer je netwerk en probeer het opnieuw.",
    "notFound": "Deze pagina bestaat niet (meer)."
  },
  "senzaRete": {
    "titolo": "Je bent offline",
    "dati": "Deze pagina kan zijn gegevens pas laden als de verbinding terug is.",
    "home": "Online partijen, toernooien en de ranglijst zijn niet beschikbaar. Je kunt nog steeds tegen de computer spelen of achter het bord op dit apparaat."
  },
  "avvisoServizio": {
    "etichetta": "Servicemelding",
    "preset": {
      "riavvio": "Geplande herstart: de server is even niet bereikbaar. Partijen die bezig zijn gaan niet verloren.",
      "riavvioAlle": "Geplande herstart om {{ora}}: de server is even niet bereikbaar. Partijen die bezig zijn gaan niet verloren.",
      "manutenzione": "Onderhoud bezig: sommige functies zijn mogelijk niet beschikbaar.",
      "manutenzioneAlle": "Onderhoud vanaf {{ora}}: sommige functies zijn mogelijk niet beschikbaar.",
      "rallentamenti": "De server is langzamer dan normaal. We werken eraan."
    }
  },
  "nav": {
    "play": "Spelen",
    "tournaments": "Toernooien",
    "leaderboard": "Ranglijst",
    "myGames": "Mijn Partijen",
    "logout": "Uitloggen",
    "signIn": "Inloggen",
    "backToLocal": "Terug naar Lokaal Spelen",
    "backToTournaments": "Terug naar Toernooien",
    "backToGames": "Terug naar Partijen",
    "home": "Home",
    "arena": "Arena",
    "profile": "Profiel",
    "loginRequired": "Inloggen vereist",
    "faq": "FAQ & Contact",
    "rules": "Regels",
    "editor": "Editor",
    "strumenti": "Tools"
  },
  "gara": {
    "torneoInCorso": "Toernooi bezig",
    "arenaInCorso": "Arena bezig"
  },
  "strumenti": {
    "titoloFoglio": "Tools (Hulpmiddelen)",
    "orologio": "Klok",
    "estraiApertura": "Opening trekken"
  },
  "orologio": {
    "titolo": "Bordklok",
    "sottotitolo": "Leg de telefoon tussen de spelers: wie gezet heeft, tikt op de eigen helft",
    "tocca": "Tik om te starten",
    "pausa": "Pauze",
    "riprendi": "Doorgaan",
    "azzera": "Opnieuw",
    "impostazioni": "Instellingen",
    "suoni": "Geluiden",
    "suonoTocco": "Geluid bij tikken",
    "suonoPocoTempo": "Geluid bij weinig tijd",
    "tempo": "Tijd",
    "stessoTempo": "Dezelfde tijd voor beiden",
    "scaduto": "Tijd verstreken",
    "mosse": "Zetten"
  },
  "apertura": {
    "sottotitolo": "Trek een officiële opening",
    "andataRitorno": "Deze opening kan één kleur bevoordelen: in wedstrijdverband speelt men heen en terug, met omgewisselde kleuren.",
    "estrai": "Trekken",
    "estraiDiNuovo": "Opnieuw trekken",
    "vediTabelle": "Bekijk de volledige tabellen",
    "posizioneIniziale": "Beginstelling"
  },
  "editor": {
    "title": "Editor",
    "subtitle": "Stel een stand samen om te studeren, analyseren of spelen",
    "boardLabel": "Bewerkbaar bord",
    "sideToMove": "Aan zet",
    "reset": "Herstellen",
    "clear": "Leegmaken",
    "flip": "Draaien",
    "playPosition": "Positie spelen",
    "playAI": "Speel tegen computer",
    "challenge": "Daag een vriend uit",
    "challengeNote": "De partij begint vanuit jouw stand en is altijd vriendschappelijk (niet gewaardeerd).",
    "tools": {
      "label": "Stukken",
      "whiteMan": "Witte schijf",
      "whiteKing": "Witte dam",
      "blackMan": "Zwarte schijf",
      "blackKing": "Zwarte dam",
      "erase": "Wissen",
      "cycle": "Stuk wisselen"
    },
    "library": {
      "open": "Opgeslagen stellingen",
      "title": "Opgeslagen stellingen",
      "nameLabel": "Naam",
      "namePlaceholder": "Naam van de stelling",
      "defaultName": "Stelling",
      "defaultNameAnalysis": "Analyse",
      "save": "Opslaan",
      "overwrite": "Overschrijven",
      "willOverwrite": "“{{name}}” wordt vervangen.",
      "saved": "In je bibliotheek",
      "empty": "Nog geen opgeslagen stellingen. Stel een stelling samen en sla die hier op.",
      "load": "{{name}} laden",
      "lineBadge_one": "{{count}} zet",
      "lineBadge_other": "{{count}} zetten",
      "askLoad": "“{{name}}” laden? De stelling op het bord wordt vervangen.",
      "askLoadLine": "“{{name}}” laden? De stelling en de variant die je speelt worden vervangen.",
      "confirmLoad": "Laden",
      "rename": "{{name}} hernoemen",
      "share": "{{name}} delen",
      "shareCopied": "Link gekopieerd",
      "shareTitle": "Damstelling",
      "shareText": "Kijk eens naar deze damstelling",
      "delete": "{{name}} verwijderen",
      "askDelete": "“{{name}}” verwijderen?",
      "confirmDelete": "Verwijderen",
      "errors": {
        "nameTaken": "Er bestaat al een stelling met deze naam.",
        "full": "Bibliotheek vol: verwijder een stelling om een nieuwe op te slaan.",
        "saveFailed": "Opslaan mislukt. Probeer het opnieuw.",
        "deleteFailed": "Verwijderen mislukt. Probeer het opnieuw.",
        "loadFailed": "Deze stelling kan niet worden gelezen.",
        "loadListFailed": "De bibliotheek kan niet worden geladen.",
        "shareFailed": "De link kon niet worden gekopieerd."
      }
    },
    "fen": {
      "label": "Stand (FEN)",
      "copy": "FEN kopiëren",
      "copied": "Gekopieerd",
      "invalid": "Ongeldige FEN."
    },
    "analysis": {
      "title": "Analyse",
      "hint": "Speel beide kleuren. Ga terug en speel een andere zet om de variant te wijzigen.",
      "save": "Analyse opslaan",
      "run": "Analyseren",
      "depth": "Diepte",
      "fast": "Snel",
      "standard": "Standaard",
      "deep": "Diep",
      "evaluation": "Evaluatie",
      "cancel": "Annuleren",
      "reached": "Bereikte diepte"
    },
    "invalid": {
      "noWhite": "Voeg minstens één witte schijf toe.",
      "noBlack": "Voeg minstens één zwarte schijf toe.",
      "manOnPromotionRow": "Een schijf mag niet op zijn promotielijn staan — maak er een dam van of verplaats hem.",
      "tooManyPieces": "Te veel stukken voor deze variant.",
      "sideToMoveNoMoves": "De partij aan zet heeft geen legale zetten.",
      "alreadyTerminal": "Deze stand is al beslist (gewonnen of remise).",
      "offBoard": "Een stuk staat op een veld dat deze variant niet heeft.",
      "duplicateSquare": "Twee stukken op hetzelfde veld."
    }
  },
  "rules": {
    "channels": {
      "cta": "Aanbevolen kanalen",
      "title": "Aanbevolen kanalen",
      "note": "Kanalen die we aanraden om deze variant te bekijken en te bestuderen.",
      "opensOnYouTube": "Opent op YouTube"
    },
    "backToRules": "Alle regels",
    "playOnline": "Nu spelen",
    "playAI": "Speel tegen computer",
    "indexTitle": "Damregels",
    "indexIntro": "Twee reglementen op één plek: de spelregels van elke variant die we ondersteunen, en de regels waarmee onze online toernooien werken.",
    "gameTitle": "Damregels per variant",
    "gameIntro": "Dammen — ook bekend als draughts, checkers, dama en damas — wordt over de hele wereld gespeeld, elke regio met eigen regels. Bekijk hieronder de regels van elke variant die we ondersteunen.",
    "gameCtaDesc": "Bord, zetten, slaan en promotie — variant per variant.",
    "heroSubtitle": "Regels, beginopstelling en hoe je {{variant}} speelt.",
    "startingPosition": "Beginopstelling",
    "howToPlay": "Hoe te spelen",
    "otherVariants": "Andere varianten",
    "eyebrow": "Regels",
    "glance": {
      "title": "In één oogopslag",
      "board": "Bord",
      "pieces": "Stukken per kant",
      "starts": "Eerste zet"
    },
    "theme": {
      "movement": "Beweging",
      "capture": "Slaan",
      "promotion": "Promotie"
    },
    "variantsLabel": "Varianten",
    "draughtsWord": "dammen",
    "tournaments": {
      "title": "Toernooiregels",
      "heroSubtitle": "Alles wat een toernooi zelf bepaalt, van het aantal ronden tot de tiebreaks.",
      "intro": "Zodra een toernooi begint, loopt het vanzelf: het telt de aanwezige deelnemers, kiest het parenstelsel, legt het aantal ronden vast en maakt de stand op. Dit zijn de regels die het toepast, in de volgorde waarin het ze toepast.",
      "source": "Bron: FIDE C.04.1 en FMJD Annex 3, aangepast aan online spel.",
      "cta": "Hoe een toernooi werkt",
      "ctaDesc": "Toernooivorm, ronden, inschrijving, afwezigheid, tiebreaks en de arena.",
      "chaptersLabel": "Hoofdstukken",
      "format": {
        "title": "Toernooivorm",
        "body": [
          "Eén formule met ronden, het systeem round robin/Zwitsers: wie een toernooi opent, kiest niet tussen een halve competitie en het Zwitserse systeem, maar kiest een drempel aan deelnemers. Naast de toernooien is er de arena, en dat is iets anders: zie het hoofdstuk “De arena”.",
          "Op het startuur worden de werkelijk ingeschreven spelers geteld. Onder de drempel wordt een halve competitie gespeeld: iedereen tegen iedereen, volgens de Berger-tabellen. Vanaf de drempel wordt het Zwitserse systeem gespeeld: elke ronde word je gekoppeld aan spelers met evenveel punten, en je treft nooit twee keer dezelfde tegenstander.",
          "De standaarddrempel is 7 en is instelbaar tussen 7 en 20; een halve competitie gaat tot hoogstens 19 deelnemers.",
          "De reden is eenvoudig: bij het openen van een toernooi weet niemand hoeveel er komen, en de formule vooraf kiezen is blind kiezen.",
          "Winst 2 punten, remise 1 punt, verlies niets. Bij een oneven aantal deelnemers is er elke ronde één vrij, en wat die vrije ronde oplevert hangt af van het format: in een Zwitsers toernooi 2 punten, net als een overwinning — 4 in een toernooi heen en terug, waar elke ronde twee partijen telt — terwijl het in een halve competitie niets oplevert, want daar speelt iedereen tegen iedereen en is de vrije ronde alleen een ronde die niet gespeeld wordt. In beide gevallen telt het niet als gewonnen partij, en telt het niet mee voor de tiebreaks."
        ]
      },
      "rounds": {
        "title": "Aantal ronden",
        "body": [
          "Dat wordt bij de start van het toernooi bepaald, op basis van de aanwezige deelnemers. Met de standaarddrempel, naar aantal deelnemers:",
          "Een toernooi gaat tot hoogstens 200 deelnemers, dus tien ronden is het maximum — elf met de extra ronde.",
          "In een halve competitie zijn het er zoveel als nodig is om iedereen tegen iedereen te laten spelen. Bij drie of vier deelnemers wordt heen en terug altijd gespeeld, wat de organisator ook koos: elke ronde telt dan twee partijen, want met maar één partij per tegenstander zou één nederlaag in de eerste ronde het toernooi al beslissen. Met vier deelnemers zijn het drie ronden en zes partijen per persoon; met drie worden dezelfde drie ronden gespeeld maar zit er elke keer iemand uit, dus ieder rust één keer en speelt vier partijen — en die rustronde levert geen punten op.",
          "In het Zwitserse systeem komt er bij elke verdubbeling van het deelnemersveld één ronde bij: elke ronde halveert het aantal spelers dat nog met een vol puntenaantal kan eindigen. Het is één ronde meer dan een knock-out nodig zou hebben, want anders kunnen twee spelers samen bovenaan eindigen zonder elkaar ooit te hebben getroffen.",
          "Twee schakelaars veranderen de telling. «Extra ronde» voegt er één toe aan de tabel wanneer het veld het aankan, en geldt alleen als de start een Zwitsers oplevert: in een halve competitie treft iedereen elkaar al, en een ronde erbij zou enkel een revanche voor iedereen zijn. «Heen en terug» voegt daarentegen geen ronden toe maar vult ze: elke koppeling wordt twee keer achter elkaar gespeeld, met omgekeerde kleuren en op dezelfde opening, binnen dezelfde ronde, die dus twee keer zo lang duurt. Het werkt hetzelfde in de halve competitie en in het Zwitserse systeem, en de punten blijven per partij: winst plus remise is 3, twee overwinningen 4."
        ],
        "rounds": [
          "3-4 — halve competitie, 3 ronden",
          "5-6 — halve competitie, 5 ronden",
          "7-8 — Zwitsers, 4 ronden",
          "9-16 — Zwitsers, 5 ronden",
          "17-32 — Zwitsers, 6 ronden",
          "33-64 — Zwitsers, 7 ronden",
          "65-128 — Zwitsers, 8 ronden",
          "129-192 — Zwitsers, 9 ronden",
          "193-200 — Zwitsers, 10 ronden"
        ]
      },
      "entry": {
        "title": "Inschrijving en terugtrekking",
        "body": [
          "Openen kan iedereen met een geregistreerd account: er is geen toestemming nodig en er is geen officiële organisator. Gasten en computers komen niet in toernooien, niet om ze te openen en niet om ze te spelen.",
          "Drie lopende wedstrijden per persoon: je kunt tot drie toernooien of arena's tegelijk open houden; voor een nieuwe wacht je tot er een is afgelopen, of je annuleert hem.",
          "Een toernooi wordt ingepland, niet met de hand gestart: het beginuur ligt tussen vijf minuten en veertien dagen vooruit. Wie het opent, organiseert het alleen maar: om mee te spelen moet hij op de toernooipagina op «Inschrijven» drukken, net als alle anderen, en zolang hij dat niet doet telt hij niet mee — een minimum van 3 vraagt drie mensen naast hem.",
          "De plaatsen lopen van 3 tot 200. Het minimum om te starten is 3, en wie opent mag dat verhogen: zijn er op het startuur minder deelnemers dan het minimum, dan annuleert het toernooi zichzelf. Zolang het niet begonnen is kan de organisator het annuleren; daarna niet meer, want wie speelt heeft het recht uit te spelen.",
          "Een toernooi kan privé zijn: je komt er alleen in met het wachtwoord dat de organisator koos, of met de uitnodigingslink.",
          "Inschrijven kan tot de eerste ronde begint, en tot dan kun je je ook terugtrekken — wie vóór de start annuleert verdwijnt meteen uit de stand, want er is nog niets gespeeld. Daarna gaat de deur in beide richtingen dicht: wie binnen is blijft in het schema, want halverwege terugtrekken zou elke resterende ronde een tegenstander zonder partij laten."
        ]
      },
      "absences": {
        "title": "Afwezigheid",
        "body": [
          "Dat hangt ervan af waar je was, en de drie gevallen lopen verschillend af.",
          "Ben je gewoon offline, dan gaat de partij tóch open en gaat jouw klok lopen. Drie minuten te laat komen betekent met drie minuten minder spelen, niet de partij verliezen: alleen als je nooit komt verlies je op tijd. Een partij waar een van de twee nooit is aangeschoven, verandert niemands rating.",
          "Hetzelfde geldt als je verbonden bent en de verbinding wegvalt vóór je eerste zet: jouw klok beslist. Na je eerste zet heb je bij een verbroken verbinding 30 seconden om terug te komen, zoals in elke partij.",
          "Zit je daarentegen al in een andere partij — een arena, een uitdaging, een ander toernooi — dan gaat de partij van die ronde helemaal niet open en krijg je een reglementaire nederlaag, met de 2 punten voor je tegenstander. Het is geen straf: een tweede bord voor je openen zou het bord waarop je al speelt onbereikbaar maken.",
          "Ontbreken jullie met z'n tweeën, dan sluit de ronde 0-0 en krijgt niemand iets. Een reglementaire remise zou de afwezigheid belonen.",
          "In geen van de drie gevallen lig je eruit: de volgende ronde word je gewoon weer gekoppeld.",
          "Eén ding geldt voor iedereen: een toernooi heeft een aangekondigde duur, en lopen er op dat moment nog partijen, dan krijgen die tien minuten. Daarna sluit het toernooi en worden de nog open partijen remise verklaard."
        ]
      },
      "openingMoves": {
        "title": "Beginzetten",
        "body": [
          "Dat hangt af van hoe het toernooi is geopend, en er zijn negen manieren.",
          "«Vrije zet» is de gewone: je speelt vanaf de eerste zet, en niemand legt iets op.",
          "Dan zijn er de lotingen. Drie daarvan leggen één, twee of drie willekeurige geldige zetten neer, en werken op elke variant. Vier andere loten uit een officiële F.I.D.-tabel, en bestaan alleen bij Italiaans en Engels, de twee varianten met een federale tabel: wat je daar kiest is hoe scheef de opening mag zijn die eruit komt — tot 1N/1B, tot 2N/2B, tot 3N/3B, of alle 174. In het Zwitserse systeem komt dezelfde opening geen twee keer in hetzelfde toernooi voor.",
          "En dan is er het thematoernooi: wie opent kiest ÉÉN van de 174 officiële openingen, en iedereen speelt die, in alle ronden en alle partijen. Het is het enige geval waarin de opening al vóór het begin bekend is, en het enige waarin de regel «nooit twee keer dezelfde» niet geldt — dat zou precies het tegendeel zijn van wat een thematoernooi vraagt.",
          "Met heen en terug worden de twee partijen van een ronde op dezelfde opening gespeeld met omgekeerde kleuren: zo houdt een scheve opening op iemand te bevoordelen."
        ]
      },
      "rated": {
        "title": "Gewaardeerde toernooien",
        "body": [
          "Als het toernooi voor rating telt wel, en niet in een aparte lijst: toernooipartijen bewegen dezelfde rating als alle andere partijen, die van de variant en het speeltempo waarin gespeeld wordt. Wie het toernooi opent beslist erover, en standaard telt het mee.",
          "Een toernooi of arena die meetelt kan een ratingdrempel hebben, dus een minimumrating om binnen te komen, in stappen van 1000 tot 2000: die wordt gemeten op je rating voor die variant en dat speeltempo, niet op een algemene. Bij vriendschappelijke competities bestaat de drempel niet, want de rating beweegt niet en er valt niets te beschermen. Een bovengrens is er niet: niemand blijft buiten omdat hij te sterk is.",
          "Er is dan nog iets dat het meetellen vanzelf kan uitschakelen, en dat is de opening. De federale regel zegt dat één partij volstaat zolang de opening tot 2N/2B gaat; daarboven is het voordeel van één kleur te groot om door één partij te worden gecompenseerd, en is heen en terug nodig. Het geldt in beide gevallen: bij een loting telt de bovengrens van de tabel waaruit geloot wordt, bij een thematoernooi telt de kracht van de gekozen opening, die daar al bekend is. Houdt de combinatie geen stand, dan wordt het toernooi vriendschappelijk aangemaakt in plaats van geweigerd — en heen en terug aanzetten maakt het weer meetellend.",
          "Tot slot tellen partijen waar een van de twee nooit is aangeschoven niet mee."
        ]
      },
      "tiebreaks": {
        "title": "Tiebreaks",
        "body": [
          "Dat hangt van de formule af.",
          "In het Zwitserse systeem, in deze volgorde:",
          "1. Buchholz Cut 1: de som van de eindscores van alle tegenstanders, min de zwakste. Beloont wie het zwaarste parcours had. Een vrije ronde telt niet mee, want dat is geen tegenstander.",
          "2. Sonneborn-Berger: de scores van de tegenstanders die je won, plus de helft van de scores van wie je remise speelde. Beloont wie de sterksten versloeg.",
          "3. Het aantal overwinningen.",
          "4. De ratingverandering in het toernooi: hoeveel ratingpunten je in de partijen van dit toernooi hebt gewonnen of verloren. Dit beloont wie beter speelde dan verwacht, niet wie al sterker was. Wie ook hierop gelijk staat, deelt de plaats.",
          "In de stand staan Buchholz en Sonneborn-Berger na winst, remise, verlies en vrije rondes, afgekort tot BH en SB.",
          "In een halve competitie gelden andere criteria, omdat iedereen tegen iedereen speelt en Buchholz niemand zou onderscheiden: eerst het aantal overwinningen, dan het onderling resultaat tussen de spelers met evenveel punten, dan Sonneborn-Berger (SB), en ten slotte de ratingverandering in het toernooi. Wie daarna nog gelijk staat, wordt gerangschikt op het startnummer in de tabel, dus op de hoogste rating bij de start van het toernooi: in een halve competitie zijn er geen gedeelde plaatsen. BH wordt er niet getoond, want als iedereen tegen iedereen speelt is het slechts het spiegelbeeld van de punten. In de stand staat «OR» bij wie voor staat op onderling resultaat."
        ]
      },
      "sharedPlaces": {
        "title": "Gedeelde plaatsen",
        "body": [
          "In het Zwitsers systeem gebeurt dat in kleine toernooien waarin alle partijen in remise eindigen: dezelfde punten, dezelfde Buchholz, dezelfde Sonneborn-Berger, niemand met een overwinning.",
          "Dan wordt de plaats gedeeld. Twee gedeelde eersten krijgen allebei goud, en de volgende plaats is de derde: 1, 1, 3, zoals in elke sportstand. Niemand wordt voor een ander gezet vanwege zijn rating of omdat hij zich eerder inschreef.",
          "Eén kanttekening: in het toernooiarchief blijft één naam als winnaar staan, want dat veld houdt er maar één. De stand en het podium tonen iedereen die gelijk eindigde."
        ]
      },
      "arena": {
        "title": "De arena",
        "body": [
          "De andere wedstrijd die je kunt openen, en het is geen toernooi met ronden: hij heeft geen ronden en geen schema, hij heeft een duur. Hij gaat open, duurt van tien minuten tot acht uur, en zolang hij open is word je opnieuw gekoppeld zodra je klaar bent, zonder te wachten tot de anderen hun partij hebben uitgespeeld. Je komt en gaat wanneer je wilt, ook als hij al bezig is.",
          "Met dezelfde persoon wacht je wel: vijf minuten voor elke partij die jullie al samen speelden. De eerste revanche komt na vijf minuten, de tweede na tien, de derde na vijftien, en er is geen bovengrens. Zo wordt een arena niet dezelfde partij die eindeloos herhaald wordt.",
          "Punten: winst 2, remise 1, verlies niets, net als in het toernooi.",
          "En er is de boost, te nemen vóór je eigen eerste zet: hij verdubbelt de punten van een overwinning en wordt met de klok betaald — de increment gaat er helemaal af, en de basistijd wordt gehalveerd. Het is een gok, geen cadeau.",
          "Bij gelijke punten telt wie meer partijen won."
        ]
      }
    },
    "seo": {
      "title": "{{variant}}: regels en hoe te spelen",
      "description": "Leer de regels van {{variant}}: bordgrootte, beginopstelling, hoe stukken en dammen bewegen en slaan, en hoe je wint. Speel {{draughtsWord}} gratis online.",
      "indexTitle": "Damregels — spelregels en toernooiregels",
      "indexDescription": "Twee reglementen voor {{draughtsWord}}: de spelregels van elke variant — internationaal, Italiaans, Turks, Fries en meer — en de regels van onze online toernooien.",
      "gameTitle": "Damregels per variant — hoe te spelen",
      "gameDescription": "Regels en speluitleg voor elke variant van {{draughtsWord}}: internationaal, Italiaans, Turks, Fries, Braziliaans en veel meer. Speel gratis online.",
      "openingsTitle": "{{variant}}: officiële F.I.D.-openingstabellen",
      "openingsDescription": "Alle 174 officiële openingen van {{variant}} met waardering en bondstabellen A, B, C en D. F.I.D. Regolamento Tecnico 2025.",
      "captureTitle": "{{variant}}: alle slagregels",
      "captureDescription": "Alle slagregels van {{variant}}: slagplicht, meervoudige slag, de rangorde die bepaalt welke slag je moet spelen, en promotie. Met voorbeelden op het bord.",
      "tournamentsTitle": "Toernooiregels — zo werkt een {{draughtsWord}}toernooi",
      "tournamentsDescription": "De regels van online {{draughtsWord}}toernooien: vorm round robin/Zwitsers, aantal ronden, inschrijving en terugtrekking, afwezigheid, de openingsloting, rating, tiebreaks en de arena."
    },
    "fact": {
      "board": "Gespeeld op een {{size}}×{{size}} bord, alleen op de donkere velden.",
      "boardAllSquares": "Gespeeld op een {{size}}×{{size}} bord, op alle velden.",
      "pieces": "Elke speler begint met {{count}} schijven.",
      "startsWhite": "Wit begint.",
      "startsBlack": "Zwart begint.",
      "moveDiagonal": "Schijven bewegen diagonaal vooruit, één veld per keer.",
      "moveOrthogonal": "Schijven bewegen orthogonaal — vooruit en opzij — één veld per keer.",
      "captureDiagonal": "Slaan gebeurt diagonaal, door over een aangrenzende schijf van de tegenstander te springen.",
      "captureOrthogonal": "Slaan gebeurt orthogonaal, door over een aangrenzende schijf van de tegenstander te springen.",
      "captureMixed": "Slaan kan zowel diagonaal als orthogonaal.",
      "menCaptureBackwardYes": "Schijven mogen zowel vooruit als achteruit slaan.",
      "menCaptureBackwardNo": "Schijven mogen alleen vooruit slaan.",
      "kingFlying": "Dammen zijn \"vliegend\": ze bewegen en slaan over een willekeurig aantal lege velden langs een lijn.",
      "kingShort": "Dammen bewegen één veld per keer (geen vliegende dammen).",
      "menCaptureKingYes": "Schijven mogen dammen slaan.",
      "menCaptureKingNo": "Schijven mogen geen dammen slaan.",
      "maxCapturePieces": "Slaan is verplicht en je moet de zet nemen die de meeste schijven slaat.",
      "maxCaptureValue": "Slaan is verplicht en je moet de slag met de hoogste waarde nemen: een dam is meer waard dan een schijf, maar twee schijven zijn meer waard dan een dam.",
      "captureMandatoryFree": "Slaan is verplicht, maar je mag vrij kiezen welke slag je maakt.",
      "kingPriorityTie": "Bij verder gelijke slagen moet je met een dam slaan, niet met een schijf.",
      "maxKingsCaptureTie": "Bij een gelijk aantal stukken moet je de zet spelen die de meeste dammen slaat.",
      "firstKingFirst": "Zijn ze dan nog gelijk, dan moet je de reeks nemen die het eerst een dam slaat.",
      "huffing": "De \"blaas\"-regel geldt: een schijf die niet sloeg, kan worden verwijderd.",
      "captureImmediateRemoval": "Elke geslagen schijf wordt direct van het bord verwijderd; dat kan in dezelfde slagbeurt extra slagen mogelijk maken.",
      "captureNoReversal": "Tijdens een meerslag mag je rechtdoor gaan of 90° draaien, maar nooit 180° omkeren tussen twee sprongen.",
      "promotionStops": "Een schijf die de laatste rij bereikt wordt dam en de zet eindigt, ook midden in een slag.",
      "promotionContinues": "Een schijf die tijdens een slag over de laatste rij gaat, blijft schijf en slaat door; hij wordt alleen dam als de zet op de laatste rij eindigt.",
      "promotionInPassing": "Een schijf die tijdens een slag de laatste rij bereikt, wordt meteen dam en gaat in dezelfde beurt verder met slaan als vliegende dam.",
      "blockedKing": "Zolang een speler nog schijven heeft, mag hij niet meer dan {{n}} achtereenvolgende gewone zetten met dezelfde dam doen; de beperkte dam mag wel slaan.",
      "frisianEndgame": "Friese eindspel-remiseregels gelden (bijv. twee dammen tegen één is remise na een vast aantal zetten).",
      "loneKingWins": "Als een speler nog maar één schijf heeft tegen de dam van de tegenstander, wordt de kant met de dam tot winnaar verklaard.",
      "singlePieceLoses": "Wie nog maar één stuk over heeft — schijf of dam — verliest onmiddellijk de partij.",
      "drawLimit": "De partij is remise na {{n}} zetten waarin alleen dammen bewegen en er niets geslagen wordt."
    },
    "openings": {
      "title": "Openingstabellen",
      "heroSubtitle": "De 174 officiële openingen van {{variant}}, met hun waardering en de bondstabel waartoe ze behoren.",
      "source": "Bron: Regolamento Tecnico F.I.D., januari 2025.",
      "cta": "Openingstabellen",
      "ctaDesc": "De 174 officiële openingen en hun waardering.",
      "intro": "In officiële wedstrijden worden de eerste drie halve zetten niet gekozen maar geloot uit een tabel. De algemene tabel bevat alle 174 openingen; de bondstabellen A, B, C en D zijn deelverzamelingen daarvan, afhankelijk van het soort ontmoeting.",
      "ratedNote": "In een directe uitdaging kun je de loting begrenzen: tot en met 2N/2B telt één partij voor de rating, daarboven is een tweekamp nodig.",
      "tableAll": "Algemeen",
      "tableA": "Tabel A",
      "tableB": "Tabel B",
      "tableC": "Tabel C",
      "tableD": "Tabel D",
      "count": "{{count}} openingen",
      "colNumber": "Nr.",
      "colOpening": "Opening",
      "colStrength": "Waardering",
      "colStrengthShort": "Waard.",
      "colTables": "Tabellen",
      "colTablesShort": "Tab.",
      "firstMove": "Eerste zet {{move}}",
      "legendTitle": "Hoe je de waardering leest",
      "legendColours": "N = Zwart (Nero), B = Wit (Bianco).",
      "legendPari": "PARI — gelijk spel.",
      "legend1": "1N / 1B — die kleur staat iets beter en heeft meer keuze.",
      "legend2": "2N / 2B — die kleur staat duidelijk beter; de tegenstander speelt verdedigend.",
      "legend3": "3N / 3B — die kleur staat formidabel: de tegenstander moet kundig spelen om remise te houden.",
      "legend4": "4N / 4B — die kleur geldt met de huidige kennis als winnend.",
      "tablesTitle": "De bondstabellen",
      "italianA": "Alleen tweekampen en koppel- of teamwedstrijden.",
      "italianB": "Standaardtabel van officiële wedstrijden; ook bruikbaar in één partij.",
      "italianC": "Deelverzameling van B voor jeugd, provinciale categorieën en promotietoernooien.",
      "italianD": "De als gewonnen beschouwde openingen: alleen tweekampen.",
      "englishA": "De tabel die normaal in tweekampen en teamwedstrijden wordt gebruikt.",
      "englishB": "Toernooien met één partij per ontmoeting.",
      "englishC": "Deelverzameling van B voor bijzondere gevallen uit het wedstrijdreglement.",
      "englishD": "De als gewonnen beschouwde openingen: alleen tweekampen.",
      "tableEvery": "Alle",
      "everyTitle": "Waarom 302 openingen er 174 worden",
      "everyIntro": "Er zijn {{total}} legale openingen van drie halve zetten, maar ze leiden tot slechts {{positions}} verschillende stellingen: de algemene tabel kiest er {{listed}}, één per stelling. Dit gebeurt met de rest.",
      "status_ballot": "In de tabel",
      "statusBallotDesc": "Lootbaar: een van de officiële openingen.",
      "statusTransposition": "Zoals nr. {{id}}",
      "statusTranspositionShort": "Zetverwisseling",
      "statusTranspositionDesc": "Dezelfde eindstelling als een opening die al in de tabel staat, bereikt via een andere zetvolgorde: dezelfde partij onder een andere naam.",
      "status_material": "Verliest een schijf",
      "statusMaterialDesc": "Na de derde halve zet staat één kleur een schijf achter zonder terugslag: dit zijn de twee combinaties die het reglement altijd al uitsluit.",
      "status_unlisted": "Niet in de tabel",
      "statusUnlistedDesc": "Een stelling die de tabel helemaal niet dekt. Er is geen mechanische reden: de bond koos de lijnen die het bestuderen waard zijn.",
      "statusDecidedDesc": "Staan wél in de tabel, maar alleen voor tweekampen: ze gelden als gewonnen voor de bevoordeelde kleur, en dus als verloren voor de ander.",
      "colPosition": "Stelling"
    },
    "capture": {
      "cta": "De slagregels",
      "ctaDesc": "De slagvolgorde, stap voor stap, met voorbeelden.",
      "title": "Slagregels",
      "heroSubtitle": "Wanneer slaan verplicht is, welke slag je moet spelen en hoe er geteld wordt, bij {{variant}}.",
      "intro": "Slaan is het strengst geregelde deel van het spel. Weten hoe je slaat is niet genoeg: je moet weten welke slag je verplicht bent te spelen. Alle regels staan hier, in precies de volgorde waarin het spel ze toepast.",
      "source": "Bron: Technisch Reglement F.I.D., januari 2025.",
      "mandatoryTitle": "Slaan is verplicht",
      "mandatoryBody": "Bestaat er aan zet ook maar één slag, dan verdwijnen alle stille zetten: het zijn geen slechte zetten, ze bestaan simpelweg niet. De plicht geldt voor de hele stelling, niet voor één schijf.",
      "mandatoryRejected": "Er staat geen straf op een vergissing: een slag die de regels schendt wordt geweigerd en de stelling blijft zoals hij was.",
      "geometryTitle": "Hoe een slag werkt",
      "geometryShortKing": "Ook een dam springt maar één veld: de schijf van de tegenstander moet er diagonaal direct naast staan.",
      "geometryLanding": "Het veld achter de geslagen schijf moet leeg zijn. Staat er iets, wat dan ook, of ligt het buiten het bord, dan bestaat die slag niet.",
      "menVsKingTitle": "Schijven en dammen",
      "menVsKingWall": "Voor een schijf is een dam van de tegenstander een muur: hij kan hem niet slaan en er niet overheen springen. Een dam vóór een groep stukken maakt die groep onaantastbaar voor schijven.",
      "menVsKingFree": "Er geldt geen beperking naar rang: elk stuk mag elk stuk slaan.",
      "multiTitle": "De meervoudige slag",
      "multiBody": "Staat de schijf na een sprong opnieuw voor een slaanbaar stuk, dan moet hij door. Halverwege stoppen is geen keuze: een onvolledige reeks is geen geldige zet.",
      "multiDirection": "Bij elke sprong mag je van richting veranderen. Een schijf wisselt echter alleen tussen zijn twee voorwaartse diagonalen: hij krijgt tijdens de reeks nooit een achterwaartse slag.",
      "multiNoTwice": "Hetzelfde stuk van de tegenstander mag niet twee keer in dezelfde reeks worden gesprongen. Over hetzelfde lege veld mag je wel zo vaak als nodig.",
      "ladderTitle": "De slagvolgorde",
      "ladderIntro": "Zijn er meerdere slagen mogelijk, dan kies je niet zelf. Het spel vergelijkt ze met deze criteria, in deze volgorde: pas als het vorige criterium meerdere slagen gelijk laat, telt het volgende.",
      "ladderWholePosition": "De vergelijking loopt over alle slagen van al je stukken. Een stuk kan dus vaststaan omdat een ander stuk een betere slag heeft.",
      "ladderNoneIntro": "Slaan is verplicht, maar welke slag je speelt mag je helemaal zelf weten. Er is geen enkele rangorde: één schijf slaan telt even zwaar als een meervoudige slag, en niets dwingt je er meer te nemen.",
      "levelLabel": "Niveau {{n}}",
      "levelMaxPieces": "Je moet de slag spelen die de meeste stukken slaat.",
      "whyMaxPieces": "Er worden stukken geteld, niet hun waarde: twee schijven verslaan één dam.",
      "levelMaxValue": "Je moet de slag met de hoogste totale waarde spelen.",
      "whyMaxValue": "Dammen wegen zwaarder dan schijven, dus wint niet altijd de langste reeks.",
      "levelWithKing": "Bij een gelijk aantal stukken moet je met een dam slaan, niet met een schijf.",
      "whyWithKing": "Het criterium gaat over het slaande stuk, niet over het geslagen stuk. Slaan een dam en een schijf evenveel stukken, dan moet de dam zetten, ook als de schijf waardevollere stukken zou nemen.",
      "levelMaxKings": "Blijft het gelijk, dan moet je de slag spelen die de meeste dammen slaat.",
      "whyMaxKings": "Hier telt de waarde van wat je wegneemt. Omdat alleen dammen dammen kunnen slaan, scheidt dit criterium uitsluitend slagen van een dam.",
      "levelFirstKing": "Blijft het gelijk, dan moet je de reeks kiezen die het eerst een dam slaat.",
      "whyFirstKing": "Er wordt naar de volgorde van de sprongen gekeken: van twee routes die dezelfde stukken nemen, wint die welke de dam bij de vroegste sprong tegenkomt.",
      "levelFree": "Blijven de slagen gelijkwaardig, dan is de keuze vrij.",
      "whyFree": "Voorbij dit punt bindt geen enkele regel de speler: twee slagen die op alle criteria gelijk zijn, mag je naar believen spelen.",
      "removalTitle": "Wanneer de stukken van het bord gaan",
      "removalEnd": "Geslagen stukken blijven tot het einde van de zet op het bord staan en gaan er pas samen af als de reeks compleet is. Daarom zie je ze tijdens een meervoudige slag nog op hun plaats staan.",
      "removalImmediate": "Het vrijgekomen veld is meteen weer beschikbaar. Hetzelfde stuk twee keer springen blijft verboden.",
      "promotionTitle": "Promotie beëindigt de slag",
      "promotionBody": "Bereikt een schijf tijdens een reeks de laatste rij, dan eindigt de zet daar: de schijf wordt dam en de beurt gaat over, ook als er vanaf dat veld nog sprongen mogelijk zouden zijn. De nieuwe dam zet pas de volgende beurt.",
      "promotionNoExemption": "Promotie geeft geen vrijstelling van de rangorde: de afgebroken reeks telt mee met de stukken die hij werkelijk sloeg. Slaat een andere slag er meer, dan is de promoverende slag ongeldig.",
      "promotionStillAMan": "Voor de rangorde telt een promoverende schijf nog steeds als schijf: hij krijgt niet de voorrang van een dam.",
      "noHuffingTitle": "Geen blazen",
      "noHuffingBody": "De \"blaas\"-regel geldt niet: wie een verplichte slag mist, verliest de schijf niet, hij kan die zet alleen niet spelen.",
      "exGeometry": "Wit springt over de schijf ernaast en landt er direct achter.",
      "exMenVsKingWall": "De schijf staat naast een dam van de tegenstander en kan hem niet slaan: er rest alleen een stille zet.",
      "exMenVsKingFree": "Hier slaat de schijf de dam net zoals elk ander stuk.",
      "exMulti": "Slechts één geldige zet: de reeks moet helemaal worden afgemaakt.",
      "exPromotion": "Wit bereikt de laatste rij, dus eindigt de zet daar — ook al staat er nog een stuk te slaan.",
      "exMaxPieces": "Twee slagen mogelijk: de ene neemt één stuk, de andere twee. Alleen de langste is geldig.",
      "exMaxValue": "Van de mogelijke slagen beslist de totale waarde van de geslagen stukken.",
      "exWithKing": "De dam en de schijf slaan elk één stuk: de dam moet zetten.",
      "exMaxKings": "Twee dammen kunnen slaan: de dam van de tegenstander moet genomen worden, niet de schijf.",
      "exFirstKing": "Twee routes van twee stukken met elk één dam: die welke de dam het eerst neemt is verplicht.",
      "exFree": "Dezelfde rondgang, beide kanten op, neemt dezelfde vier stukken: je mag kiezen.",
      "exFreeNoLadder": "De ene slag neemt één stuk, de andere twee: hier zijn ze allebei geldig.",
      "forced": "Verplichte zet",
      "choices": "Geldige zetten",
      "diagramAlt": "Voorbeeldstelling"
    },
    "gameRulesHead": "Spelregels"
  },
  "faq": {
    "title": "FAQ & Contact",
    "intro": "Veelgestelde vragen en een direct kanaal voor problemen, verzoeken en feedback.",
    "questionsTitle": "Veelgestelde vragen",
    "entries": [
      {
        "id": "install-android",
        "q": "Hoe installeer ik de app op Android?",
        "a": "De app installeer je rechtstreeks vanuit de browser — de Play Store heb je niet nodig.\n1. Open de site in Chrome (of Edge, Samsung Internet).\n2. Tik rechtsboven op het menu ⋮.\n3. Kies \"App installeren\" (of \"Toevoegen aan startscherm\") en bevestig.\nSoms toont de browser zelf een installatiebanner; die kun je ook gebruiken. Het pictogram verschijnt bij je andere apps en het spel opent schermvullend, zonder browserbalk."
      },
      {
        "id": "install-ios",
        "q": "Hoe installeer ik de app op iPhone of iPad?",
        "a": "Op iPhone en iPad werkt het anders en moet het via Safari.\n1. Open de site in Safari (in andere browsers ontbreekt de optie vaak).\n2. Tik op de knop Delen (het vierkantje met de pijl omhoog): onderaan op iPhone, bovenaan op iPad.\n3. Scrol door de lijst en kies \"Zet op beginscherm\".\n4. Tik rechtsboven op \"Voeg toe\".\niOS toont nooit automatisch een installatiemelding: zonder deze stappen komt er geen pictogram."
      },
      {
        "id": "install-desktop",
        "q": "Kan ik de app op mijn computer installeren?",
        "a": "Ja, met Chrome of Edge.\n1. Open de site.\n2. Klik rechts in de adresbalk op het installatiepictogram, of open het browsermenu en kies \"Installeren…\".\n3. Bevestig: de app opent in een eigen venster, zonder browserbalk.\nFirefox en Safari op de computer ondersteunen installeren niet — je kunt gewoon in de browser spelen en de site als favoriet opslaan."
      },
      {
        "id": "login",
        "q": "Ik kan niet inloggen op mijn account — wat moet ik doen?",
        "a": "Controleer of je e-mailadres en wachtwoord correct zijn. Als je je wachtwoord bent vergeten, gebruik dan de link \"Wachtwoord vergeten\" op het inlogscherm. Blijft het probleem bestaan, vul dan onderstaand formulier in en kies \"Inlogprobleem\"."
      },
      {
        "id": "verify-email",
        "q": "Ik heb de verificatie-e-mail niet ontvangen — hoe krijg ik hem opnieuw?",
        "a": "Open het inlogscherm, probeer in te loggen met je gegevens en klik op \"Verificatie-e-mail opnieuw versturen\". Controleer ook je spam-map."
      },
      {
        "id": "variant-request",
        "q": "Mag ik een nieuwe damvariant voorstellen?",
        "a": "Ja! Vul het contactformulier hieronder in, kies \"Nieuwe variant aanvragen\" en beschrijf de regels van de variant die je graag ondersteund wilt zien."
      },
      {
        "id": "rules-wrong",
        "q": "De regels van een variant lijken niet te kloppen — hoe meld ik dit?",
        "a": "Vul het contactformulier hieronder in en kies \"Regelcorrectie\". Vermeld om welke variant het gaat en beschrijf de regel die aangepast moet worden, bij voorkeur met een verwijzing naar de officiële bron (FMJD, FID, WCDF, enz.)."
      },
      {
        "id": "delete-account",
        "q": "Hoe verwijder ik mijn account?",
        "a": "Open je profielinstellingen: daar vind je opties om je gegevens te exporteren (AVG/GDPR) en om je account permanent te verwijderen. Verwijdering is onomkeerbaar."
      }
    ],
    "contactTitle": "Contact",
    "contactIntro": "Geen antwoord gevonden? Schrijf ons en we reageren via e-mail.",
    "category": {
      "login": "Inlogprobleem",
      "variant_request": "Nieuwe variant aanvragen",
      "rules": "Regelcorrectie",
      "other": "Anders"
    },
    "fields": {
      "name": "Naam (optioneel)",
      "email": "E-mail",
      "category": "Categorie",
      "subject": "Onderwerp",
      "message": "Bericht"
    },
    "submit": "Verzoek versturen",
    "success": "Bedankt! Je verzoek is verzonden. We reageren zo snel mogelijk via e-mail.",
    "errors": {
      "invalidEmail": "Voer een geldig e-mailadres in.",
      "subjectTooShort": "Onderwerp moet minimaal 3 tekens bevatten.",
      "messageTooShort": "Bericht moet minimaal 10 tekens bevatten.",
      "rateLimited": "Je hebt recent te veel verzoeken verstuurd. Probeer het over een uur opnieuw.",
      "submitFailed": "Verzenden mislukt. Controleer je verbinding en probeer het opnieuw."
    }
  },
  "home": {
    "heroTitle": "Dammen Online",
    "heroTagline": "Het platform voor internationaal, Italiaans en Engels dammen. Speel, doe mee aan toernooien en beklim de ranglijst.",
    "welcome": "Welkom",
    "newGame": "Nieuw Spel",
    "chooseMode": "Kies je spelmodus",
    "startNow": "Spelen",
    "vsAI": "Speel tegen AI",
    "vsAIDesc": "Oefen tegen de computer",
    "vsOnline": "Speel Online",
    "vsOnlineDesc": "Daag echte spelers uit",
    "vsFriends": "Speel met Vrienden",
    "vsFriendsDesc": "Maak of join een privé spel",
    "createTable": "Maak Tafel",
    "createTableDesc": "Nodig een vriend uit",
    "joinTable": "Join Tafel",
    "joinTableDesc": "Voer een kamerkode in",
    "enterRoomCode": "Voer de kamerkode in die je vriend deelde",
    "variant": "Variant",
    "difficulty": "Moeilijkheid",
    "timeControl": "Tijdscontrole",
    "startGame": "Start Spel",
    "playersOnline": "spelers online",
    "gamesInProgress": "spellen gaande",
    "landing": {
      "heroTitle": "Speel Dammen",
      "heroTitleAccent": "Online",
      "heroTagline": "Damvarianten van over de hele wereld. Toernooien, gerankschikt spelen, AI-tegenstanders — speel nu.",
      "playFree": "Speel Nu",
      "signUp": "Aanmelden",
      "playAsGuest": "Speel als Gast",
      "featuresLabel": "Waarom Dammen?",
      "featuresTitle": "Alles wat je nodig hebt om te spelen",
      "featuresSubtitle": "Een compleet platform gebouwd voor competitieve en recreatieve damspelers.",
      "featureTournaments": "Toernooien",
      "featureTournamentsDesc": "Swiss- en Arena-formaten met automatische koppeling, Glicko-2 ratings en realtime klassementen.",
      "featureRating": "Ratingsysteem",
      "featureRatingDesc": "Aparte Glicko-2 ratings voor varianten en tijdscontroles. Volg je voortgang.",
      "featureAI": "AI-tegenstanders",
      "featureAIDesc": "6 moeilijkheidsgraden van beginner tot expert. Oefen op elk moment, geen wachttijd.",
      "featureVariants": "Wereldvarianten",
      "featureVariantsDesc": "Van Internationaal en Italiaans tot Turks, Fries en meer — damvarianten van over de hele wereld.",
      "featureOnline": "Online spelen",
      "featureOnlineDesc": "Vind in seconden een tegenstander met matchmaking en speel gewaardeerde of vriendschappelijke partijen.",
      "featurePuzzles": "Dagelijkse puzzels",
      "featurePuzzlesDesc": "Elke dag een nieuwe puzzel in meerdere varianten. Scherp je tactiek aan en verhoog je rating.",
      "specBoard": "{{size}}-bord",
      "specPieces": "{{count}} stukken per kant",
      "specFlyingKings": "Vliegende dammen",
      "specShortKings": "Korte dammen",
      "howLabel": "Hoe?",
      "howTitle": "Begin in seconden met spelen",
      "step1Title": "Maak een Account",
      "step1Desc": "Registreer in enkele seconden. Of speel direct als gast.",
      "step2Title": "Kies je Spel",
      "step2Desc": "Kies variant, tijdscontrole en speel tegen mensen of AI.",
      "step3Title": "Klim in de Ranglijst",
      "step3Desc": "Win partijen, verdien ratingpunten en doe mee aan dagelijkse toernooien.",
      "variantsLabel": "Spelvarianten",
      "variantsTitle": "Elke damvariant, één platform",
      "variantsMoreTitle": "En nog veel meer varianten",
      "variantsAllCta": "Bekijk de regels van elke variant",
      "intlBadge": "FMJD Officieel",
      "intlDesc": "De standaard voor competitief dammen wereldwijd. Vliegende dammen, verplicht slaan en langste slagregel.",
      "italianBadge": "Traditioneel",
      "italianDesc": "De geliefde Italiaanse traditie. Stukken kunnen geen dam slaan en de meeste-stukken-slaan-regel creëert diep tactisch spel.",
      "englishBadge": "WCDF Officieel",
      "englishDesc": "Klassiek 8×8 damspel wereldwijd gespeeld. Verplichte slag, niet-vliegende dammen, stukken kunnen dammen slaan en geen achterwaartse beweging voor stukken.",
      "brazilianBadge": "Populair",
      "brazilianDesc": "De favoriete damvariant van Brazilië. 8×8 bord met vliegende dammen, verplicht langste slag en stukken kunnen achterwaarts slaan.",
      "ctaTitle": "Klaar om te spelen?",
      "ctaSubtitle": "Sluit je aan bij de community. Begin je eerste partij.",
      "ctaButton": "Begin Nu met Spelen",
      "heroCta": "Speel nu",
      "puzzleTitle": "Probeer een puzzel",
      "puzzleSubtitle": "Los deze stelling meteen op, zonder account. Maak daarna een gratis account om de puzzel van de dag te spelen en je rating te laten groeien."
    },
    "dashboard": {
      "welcomeBack": "Welkom terug",
      "recentGames": "Recente Partijen",
      "viewAll": "Alles Bekijken",
      "liveUpcoming": "Live & Aankomend",
      "allTournaments": "Alle Toernooien",
      "thisWeek": "deze week",
      "live": "LIVE",
      "join": "Deelnemen",
      "noRecentGames": "Nog geen partijen. Speel je eerste partij!",
      "noTournaments": "Geen aankomende toernooien.",
      "timeAgo": {
        "now": "zojuist",
        "minutes": "{{count}} min geleden",
        "hours": "{{count}}u geleden",
        "yesterday": "Gisteren",
        "days": "{{count}}d geleden",
        "weeks": "{{count}}w geleden",
        "months": "{{count}}m geleden"
      },
      "dailyPuzzle": {
        "title": "Dagelijkse puzzel",
        "whiteToMove": "Wit aan zet",
        "blackToMove": "Zwart aan zet"
      }
    }
  },
  "game": {
    "header": {
      "rated": "Gewaardeerd",
      "casual": "Vriendschappelijk",
      "variantRules": "Regels van de variant"
    },
    "variants": {
      "international": "Internationaal Dammen 10×10",
      "internationalShort": "Internationaal 10×10",
      "internationalMedium": "Internationaal 10×10",
      "italian": "Italiaans Dammen 8×8",
      "italianShort": "Italiaans 8×8",
      "english": "Engels Dammen 8×8",
      "englishShort": "Engels 8×8",
      "englishBadge": "WCDF Officieel",
      "englishDesc": "Klassiek 8×8 damspel wereldwijd gespeeld. Verplichte slag, niet-vliegende dammen, stukken kunnen dammen slaan en geen achterwaartse beweging voor stukken.",
      "brazilian": "Braziliaans Dammen 8×8",
      "brazilianShort": "Braziliaans 8×8",
      "frisian": "Fries Dammen 10×10",
      "frisianShort": "Fries 10×10",
      "frysk": "Frysk! 10×10",
      "fryskShort": "Frysk 10×10",
      "turkish": "Turks Dammen 8×8",
      "turkishShort": "Turks 8×8",
      "armenian": "Armeens Tama 8×8",
      "armenianShort": "Armeens 8×8",
      "russian": "Russisch Dammen 8×8",
      "russianShort": "Russisch 8×8",
      "spanish": "Spaans Dammen 8×8",
      "spanishShort": "Spaans 8×8",
      "triestine": "Triestiner Dammen 10×10",
      "triestineShort": "Triestiner 10×10",
      "canadian": "Canadees Dammen 12×12",
      "canadianShort": "Canadees 12×12",
      "nigerian": "Nigeriaans Dammen 10×10",
      "nigerianShort": "Nigeriaans 10×10",
      "ghanaian": "Ghanees Dammen 10×10",
      "ghanaianShort": "Ghanees 10×10",
      "pool": "Pool Checkers 8×8",
      "poolShort": "Pool 8×8",
      "czech": "Tsjechisch Dammen 8×8",
      "czechShort": "Tsjechisch 8×8",
      "thai": "Thais Makhos 8×8",
      "thaiShort": "Thais 8×8",
      "portuguese": "Portugees Dammen 8×8",
      "portugueseShort": "Portugees 8×8",
      "filipino": "Filipijns Dammen 8×8",
      "filipinoShort": "Filipijns 8×8",
      "malaysian": "Maleisisch Dammen 12×12",
      "malaysianShort": "Maleisisch 12×12",
      "german": "Duits Damspel 8×8",
      "germanShort": "Duits 8×8",
      "jamaican": "Jamaicaans Dammen 8×8",
      "jamaicanShort": "Jamaicaans 8×8",
      "sinhalese": "Singalees Dammen 8×8",
      "sinhaleseShort": "Singalees 8×8",
      "south_african": "Zuid-Afrikaans Dammen 14×14",
      "south_africanShort": "Zuid-Afrikaans 14×14",
      "dameo": "Dameo 8×8",
      "dameoShort": "Dameo 8×8",
      "croda": "Croda 8×8",
      "crodaShort": "Croda 8×8"
    },
    "opponent": {
      "computer": "AI"
    },
    "modes": {
      "twoPlayers": "2 Spelers",
      "aiVeryEasy": "Zeer Makkelijk",
      "aiEasy": "Makkelijk",
      "aiMedium": "Gemiddeld",
      "aiHard": "Moeilijk",
      "aiExpert": "Zeer Moeilijk",
      "aiMaster": "Expert",
      "playOnline": "Online Spelen"
    },
    "timeControls": {
      "noTimeLimit": "Geen Tijdslimiet",
      "blitz30": "Blitz 3+0",
      "blitz32": "Blitz 3+2",
      "blitz50": "Blitz 5+0",
      "blitz53": "Blitz 5+3",
      "rapid105": "Rapid 10+5",
      "rapid1510": "Rapid 15+10"
    },
    "turn": {
      "yourTurn": "Jouw beurt",
      "opponentTurn": "Tegenstander aan zet",
      "toMove": "Aan zet",
      "aiThinking": "AI denkt na...",
      "aiTurn": "AI beurt",
      "aiDeclinedDraw": "Computer weigerde het remiseaanbod",
      "whiteToMove": "Wit aan zet",
      "blackToMove": "Zwart aan zet"
    },
    "result": {
      "youWin": "Je Wint!",
      "youLose": "Je Verliest!",
      "draw": "Remise!",
      "whiteWins": "Wit Wint!",
      "blackWins": "Zwart Wint!",
      "gameOver": "Partij Afgelopen",
      "gameAbandoned": "Partij Gestaakt",
      "noWinner": "Partij beëindigd",
      "won": "Gewonnen",
      "lost": "Verloren"
    },
    "drawCountdown": {
      "aria_one": "Automatisch remise over {{count}} zet als alleen dammen bewegen",
      "aria_other": "Automatisch remise over {{count}} zetten als alleen dammen bewegen"
    },
    "frisianCountdown": {
      "aria_one": "Automatisch remise over {{count}} zet: twee dammen tegen één",
      "aria_other": "Automatisch remise over {{count}} zetten: twee dammen tegen één"
    },
    "endReason": {
      "checkmate": "geen zetten",
      "noLegalMoves": "heeft geen legale zetten meer.",
      "whiteNoMoves": "Wit heeft geen legale zetten meer.",
      "blackNoMoves": "Zwart heeft geen legale zetten meer.",
      "drawEnded": "De partij eindigde in remise.",
      "gameAbandoned": "De partij is gestaakt.",
      "noWinner": "De partij eindigde zonder winnaar.",
      "gameEnded": "De partij is afgelopen.",
      "resignation": "opgave",
      "disconnection": "verbroken",
      "fiftyMoves": "50 zetten",
      "timeout": "tijd op",
      "agreement": "remise door overeenkomst",
      "walkover": "reglementaire winst",
      "firstKing": "Eerste dam",
      "sideResigned": "{{side}} heeft opgegeven.",
      "sideTimeout": "{{side}} is door de tijd gegaan.",
      "sideNoPieces": "{{side}} heeft geen stukken meer.",
      "moveLimit": "Te veel zetten zonder slag.",
      "repetition": "Dezelfde stand drie keer herhaald.",
      "endgameDraw": "Theoretisch remise-eindspel.",
      "sideZugzwang": "{{side}} staat in zugzwang: elke zet verliest.",
      "loneKing": "Een enkele dam wint van een enkele schijf.",
      "sideSinglePiece": "{{side}} hield één stuk over.",
      "drawAgreed": "Remise bij onderling goedvinden.",
      "sideNoFirstMove": "{{side}} heeft niet op tijd gezet.",
      "noFirstMove": "Eerste zet niet op tijd gespeeld."
    },
    "actions": {
      "newGame": "Nieuw Spel",
      "resign": "Opgeven",
      "endGame": "Stop",
      "leaveGame": "Partij Verlaten",
      "backToLobby": "Terug naar Lobby",
      "offerDraw": "Remise",
      "drawOffered": "Je tegenstander biedt remise aan",
      "drawSent": "Remise aangeboden…",
      "acceptDraw": "Accepteren",
      "declineDraw": "Weigeren",
      "drawDeclined": "Je tegenstander heeft de remise geweigerd",
      "drawMoveFirst": "Eerst zetten",
      "drawMustMoveFirst": "Doe een zet voordat je opnieuw remise aanbiedt.",
      "drawNoneLeft": "Geen aanbiedingen",
      "drawLimitReached": "Je hebt al je remiseaanbiedingen in deze partij gebruikt.",
      "drawTooFast": "Te veel remiseaanbiedingen. Wacht even.",
      "requestTakeback": "Zet terugnemen",
      "takebackRequested": "Verzoek om terugname verzonden…",
      "opponentRequestsTakeback_one": "Tegenstander wil {{count}} zet terugnemen",
      "opponentRequestsTakeback_other": "Tegenstander wil {{count}} zetten terugnemen",
      "acceptTakeback": "Accepteren",
      "declineTakeback": "Weigeren",
      "takebackDeclined": "Je verzoek om terugname is geweigerd",
      "takebackAccepted": "Je verzoek om terugname is geaccepteerd",
      "takebackDisabledRated": "Terugnemen is uitgeschakeld in gewaardeerde partijen",
      "focus": "Focus",
      "focusExit": "Sluiten",
      "peek": "Gluren",
      "boardSize": "Bordgrootte",
      "boardBigger": "Groter bord",
      "boardSmaller": "Kleiner bord",
      "flipBoard": "Draaien"
    },
    "confirmLeave": "Weet je zeker dat je het spel wilt verlaten?",
    "confirmLeaveTitle": "Spel verlaten?",
    "confirmLeaveCancel": "Annuleren",
    "confirmLeaveButton": "Verlaten",
    "confirmResignTitle": "Opgeven?",
    "confirmResign": "Weet je zeker dat je wilt opgeven? Je verliest de partij.",
    "confirmEndGameTitle": "Partij beëindigen?",
    "confirmEndGame": "De partij eindigt zonder winnaar.",
    "clock": {
      "white": "Wit",
      "black": "Zwart"
    },
    "aborted": {
      "opponentLeft": "Je tegenstander vertrok voordat de partij begon — we zoeken een nieuwe tegenstander…",
      "opponentDidNotMove": "Je tegenstander heeft niet op tijd gezet — partij vervallen."
    },
    "disconnection": {
      "opponentDisconnected": "Tegenstander Losgekoppeld",
      "waitingToReconnect": "Wachten tot tegenstander opnieuw verbindt...",
      "opponentLeft": "Tegenstander heeft het spel verlaten",
      "disconnected": "Losgekoppeld",
      "notPresent": "Niet aanwezig",
      "avvisoMaiArrivato": "Tegenstander nog niet aanwezig: komt hij niet, dan win je zodra zijn klok afloopt.",
      "avvisoDecideOrologio": "Tegenstander losgekoppeld: komt hij niet terug, dan win je zodra zijn klok afloopt.",
      "avvisoGrazia": "Tegenstander losgekoppeld: komt hij niet binnen {{secondi}} s terug, dan win je.",
      "avvisoMaiArrivatoTuoTurno": "Tegenstander nog niet aanwezig: doe je zet; komt hij niet, dan win je zodra zijn klok afloopt.",
      "avvisoDecideOrologioTuoTurno": "Tegenstander losgekoppeld: doe je zet; komt hij niet terug, dan win je zodra zijn klok afloopt."
    },
    "sidebar": {
      "moves": "Zetten",
      "openingNumbered": "Opening nr. {{n}}",
      "openingDrawn": "Gelote opening",
      "chat": "Chat",
      "spectators": "Toeschouwers",
      "noMoves": "Nog geen zetten",
      "viewMove": "Bekijk stand na zet {{n}}",
      "goToStart": "Naar begin",
      "prevMove": "Vorige zet",
      "nextMove": "Volgende zet",
      "goLive": "Naar huidige stand",
      "play": "Afspelen",
      "pause": "Pauze",
      "position": "Positie in de variant",
      "showMoves": "Zetten weergeven",
      "hideMoves": "Zetten verbergen"
    },
    "blind": {
      "lastMove": "Laatste zet",
      "promoted": "Dam gehaald",
      "noPeeks": "Gespeeld zonder ook maar één keer te gluren.",
      "peeks_one": "Je hebt {{count}} keer gegluurd.",
      "peeks_other": "Je hebt {{count}} keer gegluurd."
    },
    "confirmDrawTitle": "Remise?",
    "confirmDraw": "De partij in remise beëindigen? Beide spelers moeten akkoord gaan.",
    "match": {
      "playReturn": "Speel de returnpartij"
    },
    "primaMossa": {
      "secondi_one": "{{count}}s",
      "secondi_other": "{{count}}s",
      "ariaVoid_one": "Eerste zet binnen {{count}} seconde, anders vervalt de partij",
      "ariaVoid_other": "Eerste zet binnen {{count}} seconden, anders vervalt de partij",
      "ariaForfeit_one": "Eerste zet binnen {{count}} seconde, anders verlies je reglementair",
      "ariaForfeit_other": "Eerste zet binnen {{count}} seconden, anders verlies je reglementair"
    },
    "saluto": {
      "invia": "Wens je tegenstander een goed spel",
      "mittente": "{{username}}:",
      "ancheATe": "Jij ook",
      "inviato": "Begroeting verstuurd"
    }
  },
  "online": {
    "title": "Online Spelen",
    "playOnline": "Online Spelen",
    "connecting": "Verbinden met server...",
    "connectionFailed": "Verbinding Mislukt",
    "couldNotConnect": "Kon geen verbinding maken met de spelserver.",
    "error": "Fout",
    "room": {
      "title": "Kamer",
      "code": "Kamercode",
      "shareCode": "Deel deze kamercode:",
      "playAs": "Je speelt als",
      "waitingForOpponent": "Wachten op Tegenstander"
    },
    "lobby": {
      "findMatch": "Zoek Wedstrijd",
      "matchmakingByRating": "Automatische matchmaking op basis van rating",
      "signInToMatch": "Log in om automatische matchmaking met rating te gebruiken",
      "createGame": "Maak een Partij",
      "selectVariantAndTime": "Selecteer variant en tijdscontrole",
      "createRoom": "Maak Kamer",
      "joinGame": "Doe Mee aan Partij",
      "enterRoomCode": "Voer een kamercode in om mee te doen",
      "join": "Deelnemen",
      "playWithFriends": "of speel met vrienden"
    },
    "matchmaking": {
      "findingOpponent": "Tegenstander Zoeken...",
      "matchingSimilarSkill": "We zoeken een speler met vergelijkbaar niveau...",
      "creatingRoom": "Kamer aanmaken...",
      "joiningRoom": "Deelnemen aan kamer...",
      "estimatedWait": "Geschatte wachttijd: ~{{seconds}}s",
      "timeout": "Geen tegenstander gevonden. Probeer het opnieuw."
    },
    "errors": {
      "authRequired": "Je moet ingelogd zijn om online te spelen.",
      "alreadyInQueue": "Je zoekt al naar een wedstrijd.",
      "alreadyInGame": "Je speelt al een wedstrijd.",
      "generico": "Er ging iets mis. Probeer het opnieuw.",
      "nonConnesso": "Je hebt geen verbinding met de server.",
      "partitaSparita": "Deze partij bestaat niet meer.",
      "drawOfferFailed": "Kon geen remise aanbieden.",
      "serverRestart": "De server start opnieuw op: de partij gaat straks verder. Herlaad de pagina als hij niet terugkomt.",
      "sfidaTroppeRichieste": "Je hebt te veel uitdagingen achter elkaar gestuurd. Wacht even.",
      "avversarioOffline": "Deze speler is offline gegaan.",
      "avversarioInPartita": "Deze speler speelt al een partij. Probeer het opnieuw als die klaar is.",
      "seiInGara": "Je doet mee aan een lopend toernooi of een arena: maak dat eerst af.",
      "avversarioInGara": "Deze speler speelt een toernooi of een arena.",
      "troppePosizioni": "Te veel eigen stellingen achter elkaar. Wacht even.",
      "impostazioniNonValide": "Deze instellingen kloppen niet. Controleer ze en probeer opnieuw.",
      "soloIscritti": "Deze speler kan alleen vriendschappelijke partijen spelen.",
      "sfidaGiaInVolo": "Je hebt al een uitdaging die op antwoord wacht. Annuleer die eerst.",
      "sfidaGiaMandata": "Je hebt deze speler al uitgedaagd: wacht op het antwoord."
    },
    "challenge": {
      "challenge": "Uitdagen",
      "sendChallenge": "Directe uitdaging",
      "incomingChallenge": "Inkomende Uitdaging",
      "tabBadge": "Uitdaging!",
      "send": "Verstuur",
      "accept": "Accepteer",
      "decline": "Weiger",
      "cancel": "Annuleer",
      "loginRequired": "Log in om online spelers te zien en uitdagingen te versturen",
      "waitingForResponse": "Wachten op {{username}}...",
      "declined": "Uitdaging geweigerd",
      "expired": "Uitdaging verlopen",
      "cancelled": "Uitdaging geannuleerd",
      "color": "Kleur",
      "gameType": "Speltype",
      "colorRandom": "Willekeurig",
      "rated": "Gewaardeerd (geen gasten)",
      "casual": "Vriendschappelijk",
      "gameTypeAny": "Gewaardeerd/Vriendschappelijk",
      "registeredOnly": "Alleen leden",
      "registeredOnlyNote": "Alleen geregistreerde spelers kunnen deze partij spelen.",
      "opponentGuestNoRated": "Deze tegenstander is een gast: de partij kan niet gewaardeerd worden.",
      "mode": "Modus",
      "modeNormal": "Standaard",
      "modeBreakthrough": "Breakthrough",
      "modeAntidraughts": "Antidammen",
      "modeBlind": "Blind spelen",
      "modeInfoLabel": "Over de spelmodi",
      "modeBreakthroughInfo": "Wie als eerste een schijf tot dam promoveert, wint meteen.",
      "modeAntidraughtsInfo": "Omgekeerd doel: wie geen schijven of geen zet meer heeft, wint.",
      "modeBlindInfo": "De schijven zijn onzichtbaar: je speelt uit het geheugen, als geblinddoekt. De regels blijven de gewone.",
      "opening": "Opening",
      "legs": "Partijen",
      "legsOne": "Alleen heen",
      "legsTwo": "Heen en terug",
      "openingDrawnSingleLegCasual": "Met deze opening compenseert één partij het lotingsvoordeel niet: de partij is altijd vriendschappelijk.",
      "time": "Tijd",
      "increment": "Increment",
      "noClockCasual": "Partijen zonder tijdslimiet zijn altijd vriendschappelijk.",
      "link": {
        "inviteFriend": "Nodig een vriend uit",
        "title": "Daag een vriend uit",
        "intro": "Stuur deze link naar wie je wilt: wie hem als eerste opent speelt tegen jou, ook zonder account.",
        "share": "Delen",
        "copy": "Link kopiëren",
        "copied": "Gekopieerd!",
        "copyFailed": "Kon de link niet kopiëren. Selecteer hem en kopieer hem handmatig.",
        "expiresIn": "De link is nog {{time}} geldig.",
        "startingSoon": "De partij begint zo...",
        "friendAccepted": "{{name}} heeft je uitdaging aangenomen!",
        "cancelLink": "Uitdaging annuleren",
        "shareTitle": "Dammen-uitdaging",
        "shareText": "Speel een partij dammen tegen mij!",
        "shareTextWith": "Speel een partij dammen tegen mij — {{summary}}",
        "challengesYou": "{{name}} daagt je uit voor een partij dammen",
        "playNow": "Nu spelen",
        "haveAccount": "Ik heb al een account",
        "guestCasualNote": "Als gast speel je een vriendschappelijke partij (telt niet mee voor de rating).",
        "waitingChallengerTitle": "Uitdaging aangenomen",
        "waitingChallenger": "Wachten tot {{name}} weer online is. De partij start vanzelf.",
        "unavailableTitle": "Uitdaging niet beschikbaar",
        "cancelledByChallenger": "De speler die je uitdaagde heeft de partij geannuleerd.",
        "expiredOrGone": "Deze link is verlopen of niet meer geldig. Vraag je vriend om een nieuwe.",
        "backHome": "Terug naar home"
      },
      "opening_free": "Vrije zet",
      "opening_random1": "1 willekeurige zet",
      "opening_random2": "2 willekeurige zetten",
      "opening_random3": "3 willekeurige zetten",
      "opening_ballot1": "Tabel C - 1N/1B",
      "opening_ballot2": "Tabel B - 2N/2B",
      "opening_ballot3": "Tabel {{tables}} - 3N/3B",
      "opening_ballot4": "Algemene tabel",
      "opening_single": "Vaste opening",
      "openingInfoLabel": "Over de openingen",
      "openingInfo": "De „Tabel”-opties loten uit de officiële F.I.D.-tabellen: het getal tussen haakjes zegt uit hoeveel openingen er geloot wordt, en de grens (1N/1B … 4N/4B) bepaalt hoe scheef het mag worden. Tot en met Tabel B telt één partij gewoon voor de rating; daarboven is een tweekamp nodig. De „willekeurige zetten”-opties loten juist uit alle legale zetten, zonder enige grens: vanaf 2 zetten is een tweekamp nodig.",
      "openingInfoRandom": "De eerste halve zetten worden geloot uit alle legale zetten: het getal tussen haakjes zegt hoeveel verschillende combinaties eruit kunnen komen. Deze variant heeft geen officiële openingstabellen. Vanaf 2 zetten kan de loting één kleur bevoordelen, dus telt de partij alleen als tweekamp voor de rating.",
      "openingTablesLink": "Bekijk de openingstabellen",
      "guestCannotChallenge": "Directe uitdagingen zijn voor geregistreerde spelers. Log in of maak een gratis account om ze te versturen.",
      "guestCasualInvite": "Log in of maak een gratis account om gewaardeerde partijen te spelen.",
      "changeOpponent": "Wijzigen",
      "challengePlayer": "{{username}} uitdagen",
      "tableOpen": {
        "title": "{{username}} heeft al een tafel open",
        "other": "Een andere uitdaging sturen"
      }
    },
    "status": {
      "playing": "Speelt",
      "playingWith": "Speelt tegen {{username}}",
      "waiting": "Wachtend",
      "away": "Afwezig",
      "busy": "Bezet"
    },
    "chooseOpponent": "Kies wie je uitdaagt",
    "ratingsBucket": "Ratings:",
    "onlinePlayers": "Spelers online",
    "loadingPlayers": "Spelers laden...",
    "noPlayersOnline": "Er is nu niemand anders online",
    "reloadIn": "Herladen over {{seconds}} s",
    "reloadInShort": "{{seconds}} s",
    "rematch": {
      "rematch": "Herkansing",
      "accept": "Accepteer",
      "decline": "Weiger",
      "sessionScore": "Score",
      "opponentWantsRematch": "Tegenstander wil een herkansing!",
      "declined": "Je tegenstander heeft de revanche geweigerd",
      "expired": "Het revanche-aanbod is verlopen",
      "invite": {
        "incoming": "Uitnodiging voor herkansing",
        "tabBadge": "Herkansing!",
        "message": "<b>{{name}}</b> ({{rating}}) wil een herkansing · <b>{{timeControl}}</b> · {{variant}}",
        "messageNoRating": "<b>{{name}}</b> wil een herkansing · <b>{{timeControl}}</b> · {{variant}}"
      },
      "waitingForOpponent": "Wacht op tegenstander...",
      "newOpponent": "Terug naar Home"
    },
    "match": {
      "legFirst": "Heenpartij",
      "legSecond": "Returnpartij",
      "legOf": "Partij {{leg}} van {{total}}",
      "legShort": "{{leg}}/{{total}}",
      "score": "Match",
      "returnStartsIn": "De returnpartij begint over {{seconds}}s",
      "leavingForfeits": "Als je nu weggaat, verlies je de returnpartij.",
      "ratingAtMatchEnd": "De rating wordt aan het einde van de match bijgewerkt.",
      "ready": "Klaar",
      "opponentReady": "Je tegenstander is klaar",
      "waitingOpponent": "Wachten op je tegenstander...",
      "complete": "Match afgelopen",
      "newMatch": "Nieuwe match",
      "twoLegsShort": "2 partijen"
    },
    "connectedCount": "{{count}} Online",
    "viewProfile": "Profiel",
    "connessionePersa": {
      "titolo": "Verbinding verbroken",
      "corpo": "We proberen je terug naar het bord te brengen.",
      "riprova": "Opnieuw",
      "esci": "Verlaten"
    },
    "partitaFinitaMentreEriVia": "De partij is geëindigd terwijl je weg was.",
    "sessioneAltrove": {
      "titolo": "Geopend op een ander apparaat",
      "corpo": "Je hebt het spel ergens anders geopend: hier komen geen zetten en uitdagingen meer binnen.",
      "usaQui": "Hier gebruiken"
    }
  },
  "lobby": {
    "title": "Spelen",
    "quickPlay": "Snel spelen",
    "customGame": "Aangepaste partij",
    "opponent": "Tegenstander",
    "opponentOnline": "Online (willekeurig)",
    "opponentInPerson": "Tegenover elkaar",
    "startInPerson": "Start de partij",
    "inPersonNote": "Twee spelers op hetzelfde apparaat. Telt niet mee voor je rating.",
    "openTable": "Tafel openen",
    "openTables": "Wachtende tafels",
    "noTablesInVariant": "Er staat nu geen tafel open in {{variant}}. Kies een tempo om je eigen tafel te openen.",
    "noTablesInVariantOrOther": "Er staat nu geen tafel open in {{variant}}. Kies een tempo om je eigen tafel te openen, of schuif aan bij een andere variant:",
    "otherVariants": "Andere varianten",
    "sit": "Aanschuiven",
    "cancelTable": "Annuleren",
    "waitingAtTable": "Wachten op een tegenstander",
    "inQueue": "In de wachtrij",
    "tableExpired": "Je tafel is na 10 minuten zonder tegenstander verlopen. Open er wanneer je wilt een nieuwe.",
    "customPosition": "Aangepaste stelling",
    "errors": {
      "inCompetition": "Verlaat eerst de arena of het toernooi.",
      "rateLimited": "Te veel tafels. Wacht even.",
      "tableGone": "Die tafel is niet meer beschikbaar.",
      "hostGone": "De speler die deze tafel opende is er niet meer.",
      "ownTable": "Dit is je eigen tafel.",
      "invalidSettings": "Deze instellingen zijn niet geldig.",
      "startFailed": "De partij kon niet starten. Probeer opnieuw.",
      "generic": "Er ging iets mis. Probeer opnieuw."
    }
  },
  "spectate": {
    "watch": "Bekijk",
    "watchPlayer": "Bekijk de partij van {{username}}",
    "watchPair": "Bekijk {{a}} tegen {{b}}",
    "watching": "Je kijkt mee",
    "leave": "Verlaten",
    "loading": "Partij laden...",
    "turnWhite": "Wit aan zet",
    "turnBlack": "Zwart aan zet",
    "whiteWins": "Wit wint",
    "blackWins": "Zwart wint",
    "draw": "Remise",
    "gameOver": "Partij afgelopen",
    "betweenLegs": "Heenpartij voorbij: de returnpartij begint zo",
    "unavailable": "Deze partij is niet meer beschikbaar",
    "error": {
      "notPlaying": "Deze speler speelt geen partij meer.",
      "unavailable": "Deze partij is niet meer beschikbaar.",
      "busy": "Je kunt geen partij bekijken terwijl je zelf speelt.",
      "self": "Dit is je eigen partij — open die vanaf je eigen bord."
    },
    "watchers": {
      "empty": "Er kijkt nu niemand mee."
    }
  },
  "auth": {
    "signIn": "Inloggen",
    "signUp": "Registreren",
    "preferredVariantHint": "Je kunt dit altijd wijzigen",
    "createAccount": "Account Aanmaken",
    "noAccount": "Nog geen account?",
    "hasAccount": "Heb je al een account?",
    "fields": {
      "username": "Gebruikersnaam",
      "email": "E-mail",
      "password": "Wachtwoord",
      "confirmPassword": "Bevestig Wachtwoord",
      "emailOrUsername": "E-mail of Gebruikersnaam"
    },
    "placeholders": {
      "chooseUsername": "Kies een gebruikersnaam",
      "yourEmail": "jouw@email.nl",
      "atLeast8Chars": "Minimaal 8 tekens",
      "confirmYourPassword": "Bevestig je wachtwoord",
      "enterEmailOrUsername": "Voer e-mail of gebruikersnaam in",
      "yourPassword": "Jouw wachtwoord"
    },
    "errors": {
      "passwordsNoMatch": "Wachtwoorden komen niet overeen",
      "passwordTooShort": "Wachtwoord moet minimaal 8 tekens bevatten",
      "usernameTooShort": "Gebruikersnaam moet minimaal 3 tekens bevatten",
      "passwordRequirements": "Wachtwoord moet minstens één hoofdletter, één kleine letter en één cijfer bevatten",
      "network": "Geen internetverbinding. Controleer je verbinding en probeer het opnieuw.",
      "guestLoginFailed": "Kon geen gastsessie starten. Controleer je verbinding en probeer het opnieuw.",
      "guestLoginRateLimited": "Te veel gastaanmeldingen vanaf dit netwerk. Probeer het over een paar minuten opnieuw, of log in met je account."
    },
    "validation": {
      "usernameChars": "Alleen letters, cijfers en underscores",
      "invalidEmail": "Voer een geldig e-mailadres in",
      "min8": "8+ tekens",
      "uppercase": "hoofdletter",
      "lowercase": "kleine letter",
      "number": "cijfer"
    },
    "playAsGuest": "Speel als gast",
    "guestBanner": "Je speelt als gast.",
    "guestBannerCta": "Registreer om je voortgang op te slaan.",
    "guestUpgrade": "Account aanmaken",
    "guestRestriction": "Deze functie vereist een geregistreerd account",
    "guestCannotTournament": "Registreer om deel te nemen aan toernooien",
    "guestCannotChallenge": "Registreer om spelers uit te dagen",
    "forgotPassword": "Wachtwoord vergeten?",
    "forgotPasswordDesc": "Voer je e-mailadres in en we sturen je een link om je wachtwoord te resetten.",
    "sendResetLink": "Resetlink versturen",
    "resetEmailSent": "Controleer je e-mail",
    "checkSpam": "Niet gevonden? Controleer je spammap.",
    "backToLogin": "Terug naar inloggen",
    "resetPassword": "Wachtwoord resetten",
    "resetPasswordDesc": "Voer hieronder je nieuwe wachtwoord in.",
    "newPassword": "Nieuw wachtwoord",
    "confirmPassword": "Bevestig wachtwoord",
    "resetSuccess": "Wachtwoord succesvol bijgewerkt. Je kunt nu inloggen.",
    "resetExpired": "Deze resetlink is verlopen. Vraag een nieuwe aan.",
    "resetInvalid": "Ongeldige of verlopen resetlink.",
    "verifyEmail": {
      "title": "Controleer je e-mail",
      "checkInbox": "We hebben een verificatielink gestuurd naar {{email}}. Klik op de link om je account te activeren.",
      "spamHint": "Niet gevonden? Controleer je spammap.",
      "pageTitle": "E-mailverificatie",
      "verifying": "Je e-mail wordt geverifieerd...",
      "success": "E-mail geverifieerd. Je account is actief.",
      "successAndBack": "E-mail geverifieerd. We brengen je terug naar het toernooi.",
      "verifyButton": "Verifieer mijn e-mail",
      "error": "Verificatie mislukt. Probeer het opnieuw.",
      "loginBlocked": "Verifieer je e-mail voordat je inlogt",
      "resendLink": "Verificatie-e-mail opnieuw versturen",
      "resendSent": "Verificatie-e-mail verzonden!",
      "enterEmailToResend": "Log in met je e-mailadres om de verificatie opnieuw te versturen",
      "wrongAddress": "Verkeerd adres?",
      "changeAddress": "Corrigeer het adres",
      "newAddressLabel": "Nieuw e-mailadres",
      "passwordLabel": "Het wachtwoord dat je zojuist koos",
      "changeSubmit": "Stuur naar het nieuwe adres",
      "changeSent": "Als het account bestaat en op verificatie wacht, hebben we de link naar het nieuwe adres gestuurd.",
      "changeFailed": "Het adres kon niet worden gewijzigd. Probeer het over een paar minuten opnieuw."
    }
  },
  "profile": {
    "title": "Profiel",
    "notFound": "Profiel Niet Gevonden",
    "userNotFound": "Gebruiker niet gevonden",
    "memberSince": "Lid sinds {{date}}",
    "goBack": "Terug",
    "loadingProfile": "Profiel laden...",
    "tabs": {
      "overview": "Overzicht",
      "games": "Partijen",
      "stats": "Statistieken"
    },
    "variants": {
      "all": "Alle"
    },
    "stats": {
      "rating": "Rating",
      "games": "Partijen",
      "wins": "Gewonnen",
      "losses": "Verloren",
      "draws": "Remise",
      "winRate": "Winstpercentage",
      "winRateShort": "Win ratio",
      "winLossBreakdown": "Winst · Remise · Verlies",
      "peakRating": "Hoogste",
      "streak": "Reeks",
      "bestStreak": "Beste",
      "avgTime": "Gem. Tijd",
      "title": "Gedetailleerde Statistieken",
      "comingSoon": "Binnenkort beschikbaar...",
      "loading": "Statistieken laden...",
      "noData": "Nog geen partijen gespeeld. Speel wat partijen om je statistieken te zien!",
      "byTimeControl": "Prestaties per Tijdscontrole",
      "byVariant": "Prestaties per Variant",
      "byColor": "Prestaties per Kleur",
      "general": "Algemeen",
      "asWhite": "Als Wit",
      "asBlack": "Als Zwart",
      "totalGames": "Totaal Partijen",
      "avgMoves": "Gemiddelde Zetten",
      "gamesShort": "partijen",
      "mostActive": "Actiefste spelers",
      "mostActiveEmpty": "Nog geen partijen in deze variant.",
      "viewFullLeaderboard": "Bekijk de volledige ranglijst",
      "ratingEvolution": "Ratingverloop · laatste 30 dagen",
      "chartComingSoon": "Geschiedenis binnenkort",
      "peakShort": "Top",
      "barraEsito": "{{win}}% gewonnen, {{draw}}% remise, {{loss}}% verloren",
      "percentualeVittorie": "{{rate}}% winst",
      "siglaVittorie": "W",
      "siglaPatte": "R",
      "siglaSconfitte": "V"
    },
    "games": {
      "today": "Vandaag",
      "yesterday": "Gisteren",
      "daysAgo": "{{days}} dagen geleden",
      "weeksAgo": "{{weeks}}w geleden",
      "moves": "zetten",
      "sourceArena": "Arena",
      "sourceTournament": "Toernooi",
      "loading": "Partijen laden...",
      "noGames": "Geen partijen gevonden",
      "clearFilters": "Filters wissen",
      "clearFiltersActive": "Actieve filters wissen",
      "loadMore": "Meer laden",
      "showing": "{{count}} partijen",
      "clickViewAll": "Klik op \"Alles bekijken\" voor partijgeschiedenis",
      "filterResult": "Resultaat",
      "filterTimeControl": "Tempo",
      "filterVariant": "Variant",
      "filterOpponent": "Tegenstander",
      "filters": {
        "all": "Alles",
        "wins": "Gewonnen",
        "draws": "Remise",
        "losses": "Verloren",
        "allVariants": "Alle Varianten",
        "allTimeControls": "Alle Tijdscontroles",
        "vsMe": "Tegen mij"
      }
    },
    "challenge": "Uitdagen",
    "settings": "Instellingen",
    "gameSettings": "Spelinstellingen",
    "preferredVariant": "Voorkeursvariant",
    "preferredCadence": "Voorkeurstempo",
    "accountSettings": "Account",
    "audioHaptics": "Geluid & Trillen",
    "changePassword": "Wachtwoord wijzigen",
    "changePasswordSub": "Werk je wachtwoord bij",
    "currentPassword": "Huidig wachtwoord",
    "newPassword": "Nieuw wachtwoord",
    "passwordChanged": "Wachtwoord succesvol gewijzigd",
    "analyticsLabel": "Analytische cookies",
    "language": "Taal",
    "country": "Land",
    "countryNone": "Niet ingesteld",
    "logout": "Uitloggen",
    "logoutSub": "Log uit je account",
    "exportData": "Mijn gegevens exporteren",
    "exportDataSub": "Download een JSON van je gegevens",
    "deleteAccount": {
      "button": "Account verwijderen",
      "sub": "Verwijder je account permanent",
      "title": "Account Verwijderen",
      "warning": "Deze actie is permanent en kan niet ongedaan worden gemaakt. Al je gegevens worden verwijderd.",
      "confirmPassword": "Voer je wachtwoord in ter bevestiging",
      "confirm": "Definitief verwijderen",
      "error": "Kan account niet verwijderen"
    },
    "graphics": {
      "title": "Grafisch",
      "pieceShape": "Vorm van de schijven",
      "pieceStyle": "Stijl van de schijven",
      "kingIcon": "Dam-icoon",
      "pieceColor": "Kleur schijven",
      "pieceColorAutoHint": "De kleuren van de schijven verschillen per variant.",
      "pieceMaterial": "Materiaal schijven",
      "boardColor": "Kleur dambord",
      "boardColorAutoHint": "De kleuren van het dambord verschillen per variant.",
      "boardMaterial": "Materiaal dambord",
      "boardNotation": "Bordnotatie",
      "notation": "Notatie",
      "shapes": {
        "round": "Rond",
        "donut": "Donut",
        "square": "Vierkant",
        "rhombus": "Ruit",
        "triangle": "Driehoek",
        "star": "Ster",
        "heart": "Hart"
      },
      "styles": {
        "3d-stacked-engraved": "3D gestapeld, gravure",
        "3d-stacked-smooth": "3D gestapeld, glad",
        "3d-crown": "3D met kroon",
        "flat-plain": "Plat, effen",
        "flat-engraved": "Plat, gegraveerd"
      },
      "kingIcons": {
        "crown": "Kroon",
        "ring": "Ring",
        "star": "Ster",
        "diamond": "Diamant",
        "none": "Geen"
      },
      "crownType": "Kroontype",
      "crownTypes": {
        "classic": "Klassiek",
        "plain": "Eenvoudig",
        "diadem": "Diadeem",
        "lily": "Lelie",
        "imperial": "Keizerlijk"
      },
      "pieceColors": {
        "auto": "Auto (per variant)",
        "custom": "Aangepast…",
        "italian": "Italiaans",
        "international": "Internationaal",
        "english": "Engels",
        "brazilian": "Braziliaans",
        "classic": "Klassiek",
        "white-black": "Wit/Zwart",
        "red-black": "Rood/Zwart",
        "blue-red": "Blauw/Rood",
        "orange-blue": "Oranje/Blauw (kleurenblind)",
        "silver-gold": "Zilver/Goud",
        "coral-teal": "Koraal/Turquoise",
        "green-purple": "Groen/Paars",
        "pink-navy": "Roze/Marineblauw"
      },
      "materials": {
        "plastic": "Plastic",
        "marble": "Marmer",
        "glass": "Glas",
        "wood": "Hout"
      },
      "boards": {
        "auto": "Auto (per variant)",
        "custom": "Aangepast…",
        "wood-classic": "Internationaal",
        "italian": "Italiaans",
        "english": "Engels",
        "brazilian": "Braziliaans",
        "walnut": "Walnoot",
        "green-cream": "Groen/Crème",
        "blue-grey": "Blauw/Grijs",
        "marble": "Marmer",
        "high-contrast": "Hoog contrast",
        "mahogany": "Mahonie",
        "ocean": "Oceaan",
        "purple-lavender": "Paars/Lavendel",
        "rose": "Roze"
      },
      "notations": {
        "none": "Geen",
        "numeric": "Cijfers",
        "algebraic": "Coördinaten"
      },
      "hue": "Tint",
      "customPieceLight": "Lichte schijven",
      "customPieceDark": "Donkere schijven",
      "customBoardLight": "Lichte velden",
      "customBoardDark": "Donkere velden",
      "picker": {
        "edit": "Kleuren aanpassen",
        "hex": "Hex",
        "area": "Verzadiging en helderheid",
        "saturation": "Verzadiging",
        "brightness": "Helderheid",
        "tooClose": "Deze twee kleuren lijken sterk op elkaar — schijven of velden zijn mogelijk moeilijk te onderscheiden."
      },
      "uiTheme": "Thema van de app",
      "themes": {
        "light": "Licht",
        "dark": "Donker"
      }
    },
    "game": {
      "title": "Spel",
      "moveSound": "Geluid bij zetten inschakelen",
      "lowTimeSound": "Geluid bij weinig tijd inschakelen",
      "notificationSound": "Meldingsgeluiden inschakelen",
      "vibration": "Trillen bij zetten inschakelen"
    },
    "gameplay": {
      "title": "Spel",
      "showMoveHints": "Mogelijke zetten tonen",
      "showLastMove": "Laatste zet markeren",
      "showLastMoveCaptures": "Slagen markeren",
      "premove": "Premoves inschakelen"
    },
    "avatar": {
      "title": "Kies een avatar",
      "choose": "Beschikbare avatars",
      "remove": "Geen avatar",
      "edit": "Avatar wijzigen",
      "presets": {
        "crown": "Kroon",
        "star": "Ster",
        "flame": "Vlam",
        "zap": "Bliksem",
        "shield": "Schild",
        "rocket": "Raket",
        "gem": "Edelsteen",
        "leaf": "Blad",
        "moon": "Maan",
        "sun": "Zon",
        "heart": "Hart",
        "ghost": "Spook"
      }
    },
    "viewProfileOf": "Bekijk het profiel van {{username}}",
    "report": {
      "trigger": "{{username}} rapporteren",
      "title": "{{username}} rapporteren",
      "intro": "Vertel ons wat er mis is met dit profiel. Een moderator kijkt ernaar.",
      "reasonLabel": "Reden",
      "reasons": {
        "offensive_username": "Beledigende gebruikersnaam",
        "offensive_avatar": "Beledigende profielfoto",
        "harassment": "Intimidatie of bedreiging",
        "spam": "Spam of reclame",
        "other": "Anders"
      },
      "noteLabel": "Details (optioneel)",
      "notePlaceholder": "Alles wat ons helpt het te begrijpen",
      "privacyHint": "De melding wordt {{days}} dagen bewaard voor moderatie. Het profiel is openbaar: we bewaren er geen kopie van.",
      "submit": "Melding versturen",
      "sending": "Versturen...",
      "done": "Melding verstuurd. Bedankt.",
      "errors": {
        "duplicate": "Je hebt deze speler al gerapporteerd. Een moderator kijkt ernaar.",
        "notFound": "Deze speler is niet meer beschikbaar.",
        "self": "Je kunt jezelf niet rapporteren.",
        "registeredOnly": "Je hebt een geregistreerd account nodig om hier te rapporteren.",
        "rateLimited": "Te veel meldingen. Probeer het later opnieuw.",
        "generic": "De melding kon niet worden verstuurd. Probeer het opnieuw."
      }
    }
  },
  "gamesHistory": {
    "title": "Partijgeschiedenis",
    "gamesPlayed": "{{count}} partijen gespeeld",
    "noGames": "Nog geen partijen. Speel online om ze hier te zien!",
    "signInToView": "Log in om je partijgeschiedenis te bekijken.",
    "loadingGames": "Partijen laden...",
    "loadingGame": "Partij laden...",
    "failedToLoad": "Laden van partijen mislukt",
    "moves": "{{count}} zetten"
  },
  "replay": {
    "backToGames": "Terug naar Partijen",
    "loadFailed": "We konden deze partij niet openen. Probeer het opnieuw.",
    "result": {
      "whiteWins": "Wit wint",
      "blackWins": "Zwart wint",
      "draw": "Remise"
    },
    "controls": {
      "goToStart": "Naar begin",
      "previousMove": "Vorige zet",
      "nextMove": "Volgende zet",
      "goToEnd": "Naar einde",
      "play": "Afspelen",
      "pause": "Pauze",
      "showMoves": "Zetten weergeven",
      "hideMoves": "Zetten verbergen",
      "position": "Positie in de partij"
    },
    "downloadPdn": "PDN Downloaden",
    "openInEditor": "Bestudeer in editor",
    "share": "Delen",
    "shareCopied": "Link gekopieerd!",
    "shareTitle": "Damspel",
    "shareText": "Bekijk deze dampartij",
    "shareSheet": {
      "pdnTitle": "PDN downloaden",
      "withNotes": "Met mijn notities ({{count}})",
      "withoutNotes": "Zonder notities",
      "pdnIntro": "De notities worden commentaar in het PDN-bestand."
    }
  },
  "review": {
    "save": {
      "save": "Partij opslaan",
      "saved": "Opgeslagen",
      "title": "Partij opslaan",
      "intro": "Kies een map om deze partij terug te vinden.",
      "confirm": "Opslaan",
      "remove": "Verwijderen uit opgeslagen",
      "error": "De partij kon niet worden opgeslagen"
    },
    "folders": {
      "unsorted": "Geen map",
      "newLabel": "Nieuwe map",
      "newPlaceholder": "Naam van de map",
      "create": "Aanmaken",
      "duplicate": "Er bestaat al een map met deze naam",
      "rename": "Hernoemen",
      "renameFolder": "“{{name}}” hernoemen",
      "renameLabel": "Nieuwe naam van de map",
      "renameError": "De map kon niet worden hernoemd",
      "delete": "Verwijder",
      "deleteFolder": "“{{name}}” verwijderen",
      "deleteConfirm": "Verwijderen?",
      "deleteHint": "De partijen worden niet verwijderd: ze gaan terug naar “Geen map”.",
      "deleteError": "De map kon niet worden verwijderd",
      "filterLabel": "Map",
      "savedOnly": "Alleen opgeslagen",
      "gameCount_one": "{{count}} partij",
      "gameCount_other": "{{count}} partijen"
    },
    "notes": {
      "add": "Notitie toevoegen",
      "atStart": "Notitie bij de beginstelling",
      "atMove": "Notitie bij zet {{ply}}",
      "placeholder": "Schrijf een notitie over deze stelling…",
      "save": "Notitie opslaan",
      "delete": "Notitie verwijderen",
      "jumpTo": "Ga naar de notitie bij zet {{ply}}",
      "error": "De notitie kon niet worden opgeslagen",
      "hasNote": "Deze stelling heeft een notitie"
    }
  },
  "leaderboard": {
    "title": "Ranglijst",
    "subtitle": "Top 100 Spelers",
    "loading": "Ranglijst laden...",
    "empty": "Nog geen spelers met voltooide partijen.",
    "allTime": "Rating",
    "mostGames": "Actiefste",
    "bullet": "Bullet",
    "blitz": "Blitz",
    "rapid": "Rapid",
    "classical": "Klassiek",
    "columns": {
      "rank": "#",
      "player": "Speler",
      "rating": "Rating",
      "class": "Klasse",
      "games": "Partijen",
      "days": "Dagen",
      "record": "Record"
    },
    "period": {
      "label": "Dagen",
      "days": "{{days}} dagen",
      "all": "Altijd"
    },
    "emptyPeriod": "Geen partijen in deze variant in de laatste {{days}} dagen.",
    "emptyStreak": "Niemand heeft op dit moment een actieve streak.",
    "classes": {
      "novice": "Beginner",
      "intermediate": "Gemiddeld",
      "advanced": "Gevorderd",
      "expert": "Expert",
      "master": "Meester",
      "grandmaster": "Grootmeester",
      "legend": "Legende"
    }
  },
  "tournament": {
    "title": "Toernooien",
    "subtitle": "Test je vaardigheden in competitieve toernooien",
    "list": {
      "heroTitle": "De toernooien",
      "arenasLink": "Bekijk alle arena's",
      "archive_one": "Het laatste afgelopen toernooi.",
      "archive_other": "De laatste {{count}} afgelopen toernooien."
    },
    "createTournament": "Toernooi maken",
    "formats": {
      "arena": "Arena",
      "italoSwiss": "Round robin/Zwitsers (afhankelijk van de inschrijvingen)",
      "swiss": "Zwitsers systeem",
      "roundRobin": "Round Robin (iedereen tegen iedereen)",
      "arenaShort": "Arena",
      "italoSwissShort": "Round robin/Zwitsers",
      "swissShort": "Zwitsers",
      "roundRobinShort": "Round robin"
    },
    "filters": {
      "all": "Alles",
      "live": "Live",
      "upcoming": "Aankomend",
      "variant": "Variant",
      "status": "Status",
      "international": "Internationaal",
      "italian": "Italiaans",
      "english": "Engels",
      "brazilian": "Braziliaans",
      "comingSoon": "Binnenkort",
      "owner": "Toernooien",
      "mine": "Mijn"
    },
    "sections": {
      "live": "Lopend",
      "upcoming": "Aankomend",
      "finished": "Afgelopen"
    },
    "status": {
      "live": "LIVE",
      "upcoming": "AANKOMEND",
      "finished": "AFGELOPEN",
      "scheduled": "GEPLAND",
      "cancelled": "GEANNULEERD"
    },
    "card": {
      "rated": "Gewaardeerd",
      "registered": "Ingeschreven",
      "gamesPlayed_one": "{{count}} partij gespeeld",
      "gamesPlayed_other": "{{count}} partijen gespeeld",
      "players_one": "{{count}} speler",
      "players_other": "{{count}} spelers",
      "starts": "Start {{time}}",
      "startsAt": "Start om {{time}}",
      "startsAtTomorrow": "Start morgen om {{time}}",
      "startsAtDate": "Start op {{date}} om {{time}}",
      "startsInCountdown": "Start over {{time}}",
      "startingNow": "Start nu!",
      "privateHint": "Privétoernooi: je hebt een uitnodiging of het wachtwoord nodig",
      "publicHint": "Openbaar toernooi: voor iedereen toegankelijk",
      "private": "Privé",
      "seats": "Plaatsen",
      "yourPlace": "jij {{rank}}e",
      "gettoneAlle": "Start om",
      "gettoneDomani": "Morgen om",
      "gettoneData": "{{date}} om",
      "gettoneTra": "Start over",
      "gettoneMin": "min"
    },
    "empty": {
      "live": "Geen live toernooien op dit moment.",
      "upcoming": "Geen aankomende toernooien gepland.",
      "all": "Geen toernooien beschikbaar.",
      "mine": "Je hebt nog geen toernooien. Maak er een aan of doe mee met een uitnodiging.",
      "finished": "Nog geen afgelopen toernooien.",
      "goLive": "Bekijk de lopende",
      "goUpcoming": "Bekijk de komende",
      "goFinished": "Bekijk het archief"
    },
    "loading": "Toernooien laden...",
    "notFound": "Toernooi niet gevonden",
    "detail": {
      "timeControl": "Tijdscontrole",
      "duration": "Duur",
      "players": "Spelers",
      "games": "Partijen",
      "startsIn": "Start {{time}}",
      "joinTournament": "Deelnemen aan Toernooi",
      "register": "Inschrijven",
      "unregister": "Uitschrijven",
      "leaveTournament": "Toernooi Verlaten",
      "yourStats": "Jouw Statistieken",
      "points": "Punten",
      "rank": "Rang",
      "askPassword": "Toernooiwachtwoord",
      "share": "Uitnodiging delen",
      "shareStandings": "Stand delen",
      "shareCopied": "Link gekopieerd",
      "cancelTournament": "Toernooi annuleren",
      "cancelConfirm": "Het toernooi verdwijnt en alle ingeschrevenen krijgen bericht. Dit kan niet ongedaan worden gemaakt.",
      "cancelYes": "Ja, annuleren",
      "cancelNo": "Nee, laat staan",
      "createdBy": "Gemaakt door {{username}}",
      "regenerate": "Nieuwe sleutels",
      "regenerateHint": "De oude link werkt niet meer. Kies een nieuw wachtwoord en stuur de uitnodiging opnieuw.",
      "regenerateNewPassword": "Nieuw wachtwoord",
      "regenerateConfirm": "Nieuwe sleutels maken",
      "regenerateCancel": "Laat maar",
      "regenerateDone": "Nieuwe sleutels gemaakt: de oude link werkt niet meer",
      "ratingFloor": "Minimale rating",
      "aiutoAssenza": "Wat gebeurt er als ik niet speel?",
      "aiutoApertura": "Waarom beginnen sommige partijen met al gespeelde zetten?",
      "formatoTitolo": "Hoe het format wordt bepaald",
      "formatoOraGirone": "Met de huidige inschrijvingen ({{n}}) zou het iedereen tegen iedereen worden.",
      "formatoOraSvizzero": "Met de huidige inschrijvingen ({{n}}) zou het Zwitsers worden.",
      "formatoOraPochi": "Er zijn minstens {{min}} inschrijvingen nodig om te starten: nu zijn het er {{n}}.",
      "formatoPrevisto": "Verwacht",
      "seSvizzero": "Als het Zwitsers wordt",
      "seGirone": "Als het iedereen tegen iedereen wordt",
      "punteggio": "Puntentelling"
    },
    "scoring": {
      "title": "Arena Puntentelling",
      "win": "Winst: +{{points}}",
      "draw": "Remise: +{{points}}"
    },
    "standings": {
      "title": "Klassement",
      "liveStandings": "Live Klassement",
      "empty": "Nog geen spelers. Wees de eerste om deel te nemen!",
      "morePlayers_one": "+ {{count}} andere speler",
      "morePlayers_other": "+ {{count}} andere spelers",
      "columns": {
        "rank": "#",
        "player": "Speler",
        "points": "Punten",
        "status": "Status",
        "winsDrawsLosses": "W/R/V",
        "winsDrawsLossesByes": "W/R/V/B",
        "byes": "Vrij"
      },
      "status": {
        "playing": "Speelt",
        "ready": "Klaar",
        "paused": "Gepauzeerd",
        "left": "Weg",
        "offline": "Offline",
        "assente": "Afwezig",
        "haFinito": "Wacht",
        "riposa": "Rust",
        "disconnesso": "Losgekoppeld"
      },
      "tied": "Gedeeld",
      "tiebreakHelp": "Hoe worden gelijke standen beslist?",
      "sdSigla": "OR",
      "sdSpiega": "Voor {{nomi}} op onderling resultaat tussen de spelers met evenveel punten",
      "scoreSheet": {
        "label": "Verloop: {{esiti}}",
        "outcome": {
          "win": "gewonnen",
          "winPlus": "gewonnen, meer waard",
          "draw": "remise",
          "loss": "verloren",
          "bye": "vrije ronde"
        },
        "clipped": "de oudste vallen links buiten beeld",
        "hint": "Alle partijen, laatste rechts",
        "hintRiposoSvizzero": "het vierkant is een vrije ronde en telt als een overwinning",
        "hintRiposoGirone": "het vierkant is een vrije ronde en levert geen punten op"
      }
    },
    "lobby": {
      "leaveTournament": "Toernooi Verlaten",
      "waitingForOpponent": "Wachten op tegenstander...",
      "pts": "ptn",
      "rank": "rang",
      "yourPosition": "Jouw Positie"
    },
    "timer": {
      "remaining": "Resterend",
      "finished": "Afgelopen",
      "started": "Gestart",
      "daysHours": "{{days}}d {{hours}}u"
    },
    "tabs": {
      "standings": "Klassement",
      "games": "Partijen",
      "details": "Details",
      "participants": "Deelnemers",
      "gamesPlaceholder": "Recente partijen verschijnen hier"
    },
    "rules": {
      "title": "Puntenregels"
    },
    "create": {
      "title": "Een toernooi maken",
      "infoAbout": "Over {{campo}}",
      "nameLabel": "Toernooinaam *",
      "namePlaceholder": "bijv. Zondag Blitz Arena",
      "nameRequired": "Toernooinaam is verplicht",
      "aperturaUnicaHint": "Eén opening voor alle ronden en alle partijen van het toernooi — handig voor een thematoernooi rond één opening",
      "aperturaUnicaScelta": "nr. {{id}}",
      "aperturaUnicaScegli": "Kies de opening",
      "aperturaUnicaMancante": "Kies een opening om door te gaan",
      "aperturaUnicaAmichevole": "Deze opening is te scheef voor één partij om te compenseren: het toernooi is vriendschappelijk. Met heen en terug blijft het gewaardeerd.",
      "nameLength": "Naam moet 3-100 tekens zijn",
      "descriptionLabel": "Beschrijving (optioneel)",
      "descriptionPlaceholder": "Beschrijf je toernooi...",
      "timeControlLabel": "Tijdscontrole",
      "durationLabel": "Duur",
      "startsAtLabel": "Starttijd",
      "startsAtRange": "Van 5 minuten tot 14 dagen vanaf nu.",
      "startsAtInvalid": "Kies een tijd tussen 5 minuten en 14 dagen vanaf nu.",
      "visibilityLabel": "Zichtbaarheid",
      "visibilityPublic": "Openbaar",
      "visibilityPrivate": "Privé",
      "passwordLabel": "Toernooiwachtwoord",
      "passwordHint": "Je kunt hem later teruglezen om te delen. Gebruik niet je accountwachtwoord.",
      "passwordRequired": "Een privétoernooi heeft een wachtwoord nodig",
      "estimate": "{{players}} spelers, {{rounds}} ronden → ongeveer {{duration}}, klaar rond {{end}}",
      "estimateRange": "{{players}} spelers, {{roundsMin}} tot {{roundsMax}} ronden → ongeveer {{duration}}, uiterlijk klaar om {{end}}",
      "durationOptions": {
        "30min": "30 min",
        "1hour": "1 uur",
        "1.5hours": "1,5 uur",
        "2hours": "2 uur",
        "3hours": "3 uur"
      },
      "minRatingLabel": "Min Rating",
      "maxRatingLabel": "Max Rating",
      "ratedLabel": "Gewaardeerd",
      "ratingFloorLabel": "Ratingdrempel",
      "ratingFloorHint": "Onder deze rating kun je niet meedoen. De drempel geldt voor je rating in de variant en het speeltempo van dit toernooi: wie die combinatie nooit heeft gespeeld, geldt als nieuwkomer. Alleen bij gewaardeerde toernooien.",
      "ratingFloorNone": "Geen",
      "variantLabel": "Variant",
      "variantInternational": "Internationaal (10×10)",
      "variantItalian": "Italiaans (8×8)",
      "variantEnglish": "Engels (8×8)",
      "formatLabel": "Format",
      "maxPlayersLabel": "Max. spelers",
      "thresholdLabel": "Zwitsers vanaf",
      "thresholdHint": "Vanaf {{n}} deelnemers wordt er Zwitsers gespeeld; daaronder iedereen tegen iedereen. Het aantal ronden bepaalt de start, op basis van wie er is. Bij drie of vier deelnemers wordt ook de return gespeeld: nog altijd drie ronden, maar van twee partijen elk, want één partij per tegenstander zou te weinig zijn.",
      "extraRoundLabel": "Extra rondes (Zwitsers)",
      "extraRoundHint": "Eén of twee rondes meer dan de tabel geeft, zover het deelnemersveld het aankan. In een round robin verandert het niets: daar ontmoet iedereen iedereen, en één ronde meer zou voor allen een return zijn.",
      "extraRoundsNone": "Geen",
      "extraRoundsOne": "+1 ronde",
      "extraRoundsTwo": "+2 rondes",
      "tooLongWarningSeats": "Meer dan een dag spelen: haal er plaatsen af of kort de bedenktijd in.",
      "minPlayersLabel": "Min. spelers",
      "minPlayersHint": "Onder dit aantal annuleert het toernooi zichzelf op het starttijdstip. Hoe hoger je het zet, hoe waarschijnlijker dat gebeurt.",
      "seatsWarning": "Boven dit aantal kan niemand er nog bij, en je kunt het later niet meer wijzigen.",
      "submitButton": "Toernooi Maken",
      "submitting": "Aanmaken...",
      "failedToCreate": "Toernooi maken mislukt",
      "arenaHint": "Een arena heeft geen rondes: je wordt doorlopend gekoppeld tot de tijd om is.",
      "arenaDurationHint": "Hoe lang de arena open blijft. Maximaal acht uur.",
      "arenaSummary": "Arena van {{duration}}, eindigt rond {{end}}",
      "twoLegLabel": "Heen en terug",
      "twoLegHint": "Elke koppeling wordt twee keer achter elkaar gespeeld, met omgedraaide kleuren.",
      "twoLegItaloHint": "Dezelfde twee spelers treffen elkaar twee keer in dezelfde ronde, met omgedraaide kleuren en dezelfde opening: de ronde duurt twee keer zo lang, het aantal ronden verdubbelt niet. Bij drie of vier deelnemers wordt de return altijd gespeeld, wat deze schakelaar ook zegt.",
      "boostLabel": "Boost",
      "boostHint": "Wie speelt kan wedden: je geeft de helft van de basistijd en het increment op, en een overwinning telt dubbel. Je neemt hem vóór je eigen eerste zet. Uitgeschakeld gebruikt niemand hem in deze arena.",
      "roundsHelp": "Hoeveel ronden worden er gespeeld?"
    },
    "games": {
      "allGames": "Alle partijen",
      "myGames": "Mijn partijen",
      "noGames": "Nog geen partijen gespeeld",
      "moves": "zetten",
      "analyze": "Analyseer",
      "round": "Ronde {{n}}"
    },
    "participants": {
      "sortByScore": "Op score",
      "sortByRating": "Op rating",
      "sortByName": "A-Z",
      "status": {
        "playing": "Speelt",
        "online": "Online",
        "offline": "Offline"
      }
    },
    "matchFound": {
      "title": "Tegenstander gevonden!",
      "opponent": "Tegenstander",
      "playAsWhite": "Speel met wit",
      "playAsBlack": "Speel met zwart",
      "startingIn": "Start over...",
      "startNow": "Nu starten"
    },
    "postGame": {
      "currentRank": "Huidige rang",
      "continue": "Doorgaan"
    },
    "signInToJoin": "Log in om deel te nemen aan toernooien",
    "roundRobin": {
      "scontroDiretto": "Onderling resultaat tussen de spelers met evenveel punten (in de stand «OR»)",
      "tiebreakerInfo": "Tiebreakers: overwinningen, onderling resultaat, Sonneborn-Berger, ratingverandering in het toernooi"
    },
    "swiss": {
      "roundOf": "Ronde {{current}} van {{total}}",
      "scoringWin": "Winst: +{{points}}",
      "scoringDraw": "Remise: +{{points}}",
      "scoringLoss": "Verlies: {{points}}",
      "buchholz": "BH",
      "sb": "SB",
      "variazione": "Δ",
      "variazioneTitolo": "Ratingverandering in het toernooi",
      "criterioVittorie": "Aantal overwinningen",
      "tiebreakersTitle": "Tiebreaks",
      "buchholzCut1": "Buchholz (Cut 1)",
      "sonnebornBerger": "Sonneborn-Berger (SB)",
      "cannotJoinInProgress": "Dit Swiss toernooi is al bezig. Je kunt niet meer deelnemen.",
      "returnLegPending": "De returnpartij begint zo: dezelfde tegenstanders, omgedraaide kleuren.",
      "waitingBetweenRounds": "Wachten op volgende ronde...",
      "waitingFinalResults": "Wachten op de einduitslag...",
      "waitingForRoundEnd": "Wachten op einde van de ronde...",
      "tiebreakerInfo": "Tiebreakers: Buchholz Cut 1, Sonneborn-Berger, overwinningen, ratingverandering in het toernooi",
      "byeRoundPunti": "Deze ronde rust je: +{{punti}} punten, al in de stand.",
      "byeRoundNessunPunto": "Deze ronde rust je: in een halve competitie levert de vrije ronde geen punten op.",
      "byeProssimoTurno": "De volgende ronde begint vanzelf als de andere partijen klaar zijn.",
      "byeUltimoTurno": "De eindresultaten komen als de andere partijen klaar zijn.",
      "returnLegTra": "De returnpartij begint over {{secondi}} s: dezelfde tegenstanders, omgedraaide kleuren.",
      "partiteConcluse": "Partijen klaar: {{completate}} van {{totali}}",
      "turnoParteDaSolo": "De volgende ronde start vanzelf",
      "nonCiSiRitira": "Zodra het toernooi begonnen is kun je je niet terugtrekken: speel je niet, dan blijf je ingedeeld en verlies je je partijen op tijd."
    },
    "errors": {
      "authRequired": "Meld je aan om aan een toernooi deel te nemen.",
      "guestNotAllowed": "Toernooien zijn voor geregistreerde accounts.",
      "notAllowed": "Niet toegestaan.",
      "notFound": "Dit toernooi bestaat niet meer.",
      "userNotFound": "Speler niet gevonden.",
      "invalidInput": "Ongeldig verzoek.",
      "rateLimited": "Te veel verzoeken — wacht even.",
      "joinFailed": "Deelnemen mislukt. Probeer opnieuw.",
      "arenaPiena": "Deze arena is vol: er zijn geen plaatsen meer.",
      "arenaChiusa": "Deze arena neemt geen inschrijvingen meer aan.",
      "giaIscritto": "Je bent al ingeschreven voor deze arena.",
      "arenaAnnullata": "Deze arena is geannuleerd: bij de start waren er te weinig deelnemers.",
      "notJoinable": "Dit toernooi is gesloten voor nieuwe inschrijvingen.",
      "roundsStarted": "De ronde is al begonnen.",
      "ratingTooLow": "Je rating is lager dan het minimum van dit toernooi.",
      "wrongFormat": "Toernooiformaat komt niet overeen.",
      "privateTournament": "Dit toernooi is privé: je hebt de link of het wachtwoord nodig.",
      "wrongPassword": "Verkeerd wachtwoord.",
      "tooManyAttempts": "Te veel pogingen. Probeer het over een kwartier opnieuw.",
      "tournamentFull": "Het toernooi zit vol.",
      "alreadyHasLive": "Je hebt al 3 lopende wedstrijden: je kunt er een nieuwe openen zodra een ervan is afgelopen.",
      "nameTaken": "Er is al een toernooi met deze naam op dat tijdstip.",
      "startTooSoon": "Te snel: laat minstens vijf minuten om iemand uit te nodigen.",
      "startTooFar": "Te ver vooruit: hooguit twee weken vanaf nu.",
      "notOrganizer": "Alleen de organisator kan dit doen.",
      "alreadyStarted": "Het toernooi is al begonnen.",
      "tooLong": "Het toernooi zou langer dan een dag duren: haal er ronden af of kort de bedenktijd in.",
      "cancelledByOrganizer": "De organisator heeft dit toernooi geannuleerd.",
      "cancelledNoPlayers": "Het toernooi is geannuleerd: er hebben zich te weinig spelers aangemeld.",
      "serverError": "Serverfout. Probeer het later opnieuw.",
      "offline": "Je lijkt offline — controleer je verbinding.",
      "timeout": "De server antwoordde niet. Probeer opnieuw.",
      "loadFailed": "Kon de toernooien niet laden.",
      "notYourTurn": "Het is niet jouw zet.",
      "drawOfferFailed": "Kon geen remise aanbieden.",
      "unknown": "Er is iets misgegaan. Probeer opnieuw.",
      "moveRejected": "De server weigerde je zet: het bord staat weer zoals het was.",
      "partitaSvanita": "De partij staat niet meer op de server: die is vermoedelijk herstart. Je bent terug in de toernooilobby.",
      "notInTournament": "Je bent niet ingeschreven voor dit toernooi.",
      "tournamentFullWayOut": "Bekijk andere toernooien en arena's",
      "notPrivate": "Dit toernooi is openbaar: er zijn geen sleutels te vernieuwen",
      "samePassword": "Het nieuwe wachtwoord is hetzelfde als het oude",
      "tournamentCancelled": "Het toernooi is geannuleerd.",
      "inviteLinkExpired": "Deze uitnodigingslink werkt niet meer: doe mee met het wachtwoord."
    },
    "ended": {
      "title": "Toernooi afgelopen",
      "winner": "Winnaar",
      "noWinner": "Geen winnaar: er zijn geen partijen gespeeld.",
      "tiedWith": "Gedeelde eerste plaats met {{players}}"
    },
    "share": {
      "title": "Damtoernooi",
      "text": "Je bent uitgenodigd voor het toernooi {{nome}} op draughtsgame.com",
      "standingsTitle": "Eindstand — {{nome}}"
    }
  },
  "chat": {
    "title": "Chat",
    "openChat": "Chat openen",
    "closeChat": "Chat sluiten",
    "empty": "Nog geen berichten. Zeg hallo!",
    "placeholder": "Typ een bericht...",
    "unavailable": "Chat niet beschikbaar",
    "opponentLeft": "Je tegenstander heeft de partij verlaten.",
    "rateLimited": "Je typt te snel: wacht een paar seconden.",
    "closingIn": "De chat sluit over {{seconds}}s",
    "closed": "De chat van deze partij is gesloten.",
    "guestHint": "Gasten kunnen snelle reacties sturen. Registreer je voor de volledige chat.",
    "report": {
      "trigger": "Melden",
      "title": "{{username}} melden",
      "intro": "Vertel ons wat er is gebeurd. Een moderator bekijkt de chat van deze partij.",
      "quoteLabel": "Laatste bericht van {{username}}",
      "reasonLabel": "Reden",
      "reasons": {
        "insult": "Beledigingen of grof taalgebruik",
        "harassment": "Intimidatie of bedreiging",
        "hate_speech": "Haatzaaien of discriminatie",
        "spam": "Spam of reclame",
        "other": "Iets anders"
      },
      "noteLabel": "Details (optioneel)",
      "notePlaceholder": "Alles wat ons helpt het te begrijpen",
      "privacyHint": "De chat van deze partij (tot 100 berichten, van beide spelers) wordt bewaard voor moderatie en {{days}} dagen bewaard.",
      "submit": "Melding versturen",
      "sending": "Versturen...",
      "done": "Melding verstuurd. Bedankt.",
      "muted": "Je hebt deze speler gemeld. Zijn berichten zijn verborgen.",
      "errors": {
        "gone": "Deze partij is voorbij en de chat is niet meer te verifiëren. Schrijf ons via de Help-pagina.",
        "duplicate": "Je hebt deze speler al gemeld voor deze partij.",
        "notReportable": "Deze tegenstander kan niet gemeld worden.",
        "notInGame": "Je speelt deze partij niet.",
        "rateLimited": "Te veel meldingen. Probeer het later opnieuw.",
        "generic": "De melding kon niet worden verstuurd. Probeer het opnieuw."
      }
    },
    "quickPhrases": "Snelle zinnen",
    "presets": {
      "hello": "Hallo!",
      "goodLuck": "Goed spel!",
      "haveFun": "Veel plezier!",
      "goodGame": "Goede partij!",
      "untilNext": "Tot de volgende keer!",
      "thanks": "Bedankt!"
    }
  },
  "landing": {
    "nav": {
      "title": "Dama Online",
      "play": "Spelen",
      "tournaments": "Toernooien",
      "learn": "Leren",
      "community": "Community",
      "login": "Inloggen"
    },
    "hero": {
      "badge": "De Ultieme Dam Ervaring",
      "title": "Word een Meester in Dammen",
      "subtitle": "Speel tegen spelers wereldwijd, doe mee aan toernooien en verbeter je vaardigheden met onze geavanceerde trainingstools.",
      "playFree": "Speel Nu",
      "watchDemo": "Bekijk Demo"
    },
    "stats": {
      "players": "Actieve Spelers",
      "games": "Gespeelde Partijen",
      "variants": "Spelvarianten",
      "tournaments": "Dagelijkse Toernooien"
    },
    "features": {
      "title": "Waarom Kiezen voor Dama Online?",
      "subtitle": "Alles wat je nodig hebt om een dam meester te worden",
      "variants": {
        "title": "Meerdere Varianten",
        "description": "Speel Italiaans, Internationaal, Engels en Braziliaans dammen - alles op één platform."
      },
      "matchmaking": {
        "title": "Slim Matchmaking",
        "description": "Ons Glicko-2 ratingsysteem zorgt voor eerlijke en competitieve wedstrijden."
      },
      "tournaments": {
        "title": "Arena Toernooien",
        "description": "Strijd in dagelijkse toernooien met spelers van over de hele wereld."
      },
      "ai": {
        "title": "AI Training",
        "description": "Oefen tegen onze geavanceerde AI met meerdere moeilijkheidsgraden."
      },
      "analysis": {
        "title": "Partij Analyse",
        "description": "Bekijk je partijen en leer van je fouten met gedetailleerde analyse."
      },
      "community": {
        "title": "Actieve Community",
        "description": "Word lid van clubs, chat met spelers en maak vrienden die je passie delen."
      }
    },
    "variants": {
      "title": "Speel Je Favoriete Variant",
      "subtitle": "We ondersteunen de populairste damvarianten van over de hele wereld",
      "pieces": "stukken",
      "italian": "Italiaans Dammen",
      "international": "Internationaal Dammen",
      "english": "Engels Dammen",
      "brazilian": "Braziliaans Dammen"
    },
    "testimonials": {
      "1": {
        "name": "Marco B.",
        "role": "Toernooi Speler",
        "text": "Het beste damplatform dat ik ooit heb gebruikt. Het matchmaking is eerlijk en de toernooien zijn spannend!"
      },
      "2": {
        "name": "Elena V.",
        "role": "Casual Speler",
        "text": "Ik hou ervan hoe makkelijk het is om een partij te vinden. De interface is mooi en intuïtief."
      },
      "3": {
        "name": "Hans K.",
        "role": "Club Kampioen",
        "text": "Eindelijk een platform dat internationaal dammen serieus neemt. Zeer aanbevolen!"
      },
      "title": "Wat Spelers Zeggen"
    },
    "cta": {
      "title": "Klaar om te Spelen?",
      "subtitle": "Sluit je aan bij duizenden spelers en begin vandaag je dam reis.",
      "button": "Begin Nu te Spelen"
    },
    "footer": {
      "tagline": "Het premier online dam platform",
      "game": "Spel",
      "playNow": "Speel Nu",
      "tournaments": "Toernooien",
      "leaderboard": "Ranglijst",
      "puzzles": "Puzzels",
      "learn": "Leren",
      "tutorial": "Tutorial",
      "strategies": "Strategieën",
      "rules": "Regels",
      "videos": "Video's",
      "community": "Community",
      "forum": "Forum",
      "clubs": "Clubs",
      "blog": "Blog",
      "discord": "Discord",
      "rights": "Alle rechten voorbehouden."
    }
  },
  "arena": {
    "title": "Arena",
    "subtitle": "Snel doorlopend spel",
    "ending": "Eindigt...",
    "status": {
      "live": "LIVE",
      "upcoming": "AANKOMEND",
      "finished": "AFGELOPEN"
    },
    "card": {
      "yourPlace": "jij {{rank}}e"
    },
    "actions": {
      "join": "Deelnemen aan Arena",
      "leave": "Arena Verlaten",
      "play": "Spelen",
      "pause": "Pauzeren",
      "resume": "Verder Spelen",
      "boost": "Boost",
      "backToGame": "Terug naar de partij",
      "retry": "Opnieuw"
    },
    "errors": {
      "authRequired": "Je moet ingelogd zijn om aan de arena mee te doen.",
      "guestNotAllowed": "Gasten kunnen niet aan een arena meedoen. Maak een account aan om je partijen te bewaren.",
      "notAllowed": "Met dit account kun je niet aan een arena meedoen.",
      "arenaNotFound": "Deze arena bestaat niet meer.",
      "userNotFound": "We kunnen je account niet vinden. Log opnieuw in.",
      "invalidInput": "Het verzoek was ongeldig. Herlaad de pagina en probeer het opnieuw.",
      "rateLimited": "Te veel pogingen. Wacht een paar seconden en probeer het opnieuw.",
      "ratingTooLow": "Je rating is lager dan het minimum van deze arena.",
      "joinFailed": "Deelnemen aan de arena is niet gelukt. Probeer het opnieuw.",
      "arenaPiena": "Deze arena is vol: er zijn geen plaatsen meer.",
      "arenaChiusa": "Deze arena neemt geen inschrijvingen meer aan.",
      "giaIscritto": "Je bent al ingeschreven voor deze arena.",
      "arenaScaduta": "De tijd van deze arena is om: er wordt alleen nog gewacht op het einde van de laatste partijen.",
      "arenaAnnullata": "Deze arena is geannuleerd.",
      "arenaAnnullataPochiIscritti": "Deze arena is geannuleerd: bij de start waren er te weinig deelnemers.",
      "arenaAnnullataDaOrganizzatore": "Wie deze arena heeft geopend, heeft haar afgeblazen.",
      "notOrganizer": "Alleen wie de arena heeft geopend kan dit doen.",
      "alreadyStarted": "De arena is al begonnen.",
      "giaInUnArena": "Je zit al in een lopende arena: verlaat die om in deze te spelen",
      "leaveFailed": "De arena verlaten is niet gelukt. Probeer het opnieuw.",
      "notInArena": "Je doet niet mee aan deze arena.",
      "notInGame": "Je speelt deze partij niet.",
      "gameNotFound": "Deze partij bestaat niet meer.",
      "tooLate": "De boost kan alleen vóór je eerste zet aan of uit.",
      "boostDisabled": "In deze arena staat de boost uit.",
      "alreadyBoosted": "De boost staat al aan in deze partij.",
      "notBoosted": "De boost staat niet aan in deze partij.",
      "boostFailed": "De boost aanzetten is niet gelukt. Probeer het opnieuw.",
      "unboostFailed": "De boost uitzetten is niet gelukt. Probeer het opnieuw.",
      "serverError": "Er is iets misgegaan aan onze kant. Probeer het opnieuw.",
      "offline": "Geen verbinding met de server.",
      "timeout": "De server gaf geen antwoord. Probeer het opnieuw.",
      "unknown": "Er is iets misgegaan. Probeer het opnieuw.",
      "notYourTurn": "Je bent niet aan zet.",
      "drawOfferFailed": "We konden je remiseaanbod niet versturen. Probeer het opnieuw.",
      "moveRejected": "De server heeft je zet geweigerd: het bord staat weer zoals het was."
    },
    "standings": {
      "search": "Zoek een speler",
      "searchEmpty": "Geen speler met die naam.",
      "sheetHint": "Alle partijen, laatste rechts · goud = bonus",
      "loadMore": "Toon meer",
      "sheet": "Partijen",
      "toClimb_one": "{{count}} punt om te stijgen",
      "toClimb_other": "{{count}} punten om te stijgen",
      "lead_one": "{{count}} punt voorsprong",
      "lead_other": "{{count}} punten voorsprong",
      "boostOn": "boost actief",
      "searchScope": "Zoeken kijkt alleen naar de al geladen rijen: laad de rest om iedereen te doorzoeken.",
      "justPlayedHint": "Het teken ↺: je hebt net tegen deze speler gespeeld — ernaast staat hoelang het nog duurt voordat hij weer kan worden toegewezen.",
      "justPlayedIn": "Al gespeeld: weer beschikbaar over {{time}}"
    },
    "info": {
      "details": "Details",
      "scoring": "Puntensysteem",
      "loss": "Verlies: {{points}}",
      "boostTitle": "Boost ⚡",
      "boostTimeCost": "Haalt je increment weg en halveert je basistijd",
      "boostExtraPoint": "Verdubbelt je winstpunten als je wint",
      "boostBeforeFirst": "Kan aan en uit tot je eerste zet"
    },
    "matchFound": {
      "title": "Tegenstander Gevonden",
      "opponent": "Tegenstander",
      "playAsWhite": "Je speelt met wit",
      "playAsBlack": "Je speelt met zwart",
      "startingIn": "Start over",
      "startNow": "Start Nu"
    },
    "gameEnd": {
      "win": "Overwinning",
      "loss": "Verlies",
      "draw": "Remise",
      "pointsEarned": "Punten verdiend",
      "basePoints": "Basispunten",
      "boostBonus": "Boostbonus",
      "total": "Totaal",
      "pointsVoided": "Partij niet meegeteld: geen punten voor beide spelers",
      "rank": "Positie",
      "totalPoints": "Punten",
      "paused": "Je bent gepauzeerd: hervat wanneer je wilt.",
      "arenaFinished": "Arena afgelopen",
      "arenaDraining": "Tijd om: de arena sluit zodra de laatste partijen klaar zijn.",
      "analyze": "Analyseren",
      "pause": "Gepauzeerd",
      "playNext": "Doorgaan",
      "backToArena": "Terug naar de arena",
      "resumeFailed": "We konden je niet terug in de wachtrij zetten: controleer je verbinding en probeer het opnieuw.",
      "returnLegIn_one": "Returnpartij over {{count}} seconde…",
      "returnLegIn_other": "Returnpartij over {{count}} seconden…"
    },
    "game": {
      "boost": "Boost",
      "boostRemove": "Verwijderen",
      "boostRetry": "Opnieuw"
    },
    "confirmBoost": {
      "title": "Boost activeren?",
      "halve": "Je basistijd gaat van {{prima}} naar {{dopo}} en je verliest de increment van {{incremento}}s.",
      "halveOnly": "Je basistijd gaat van {{prima}} naar {{dopo}}.",
      "reward": "Als je wint tellen je punten dubbel. Je kunt hem verwijderen tot je eerste zet.",
      "confirm": "Activeren"
    },
    "results": {
      "arenaFinished": "Arena Afgelopen",
      "yourPosition": "Jouw positie",
      "outOf_one": "van {{count}} speler",
      "outOf_other": "van {{count}} spelers",
      "yourStats": "Jouw Statistieken",
      "totalPoints": "Totaal punten",
      "gamesPlayed": "Gespeelde partijen",
      "games": "partijen",
      "wins": "Winst",
      "draws": "Remise",
      "losses": "Verlies",
      "winRate": "Winstpercentage",
      "boostUsed": "Boosts gebruikt",
      "share": "Delen",
      "nextArena": "Volgende Arena",
      "unavailable": "We hebben de uitslag van deze arena niet.",
      "unavailableSub": "Ga terug naar de lijst en open hem opnieuw via het tabblad \"Afgelopen\"."
    },
    "tabs": {
      "rules": "Regels"
    },
    "signInToJoin": "Log in om deel te nemen aan arena's",
    "positionCta": "Doe mee en strijd om de top van het klassement!",
    "band": {
      "searchingTitle": "Ik zoek een tegenstander",
      "searchingSub": "Zodra ik een koppeling vind, breng ik je naar de partij.",
      "drainingTitle": "De tijd is om",
      "drainingSub": "Ik koppel niemand meer: zodra de laatste partijen klaar zijn, komt de eindstand.",
      "pausedTitle": "Je staat op pauze",
      "pausedSub": "Niemand wordt aan je gekoppeld tot je hervat.",
      "pausedAwaySub": "Ik heb je gepauzeerd omdat de app op de achtergrond stond. Hervat wanneer je wilt.",
      "pausedOfflineSub": "Ik heb je gepauzeerd omdat je offline was toen de arena begon.",
      "pausedOtherArenaSub": "Je speelt in de andere arena. Als je daar klaar bent, druk je op Hervatten om hier weer in de wachtrij te komen.",
      "playingTitle": "Je zit in een partij",
      "playingSub": "De partij loopt nog: ga terug.",
      "playingSubVs": "Tegen {{opponent}} · met {{color}}.",
      "waitingTitle": "Je doet mee",
      "waitingSub": "De arena is nog niet begonnen.",
      "joinTitle": "Je doet niet mee",
      "joinSub": "Doe mee en ik koppel je aan wie in de rij staat."
    },
    "timebar": {
      "endsIn": "Eindigt over"
    },
    "games": {
      "mine": "Van mij",
      "deletedPlayer": "Verwijderde speler",
      "loadFailed": "We konden de partijen niet laden."
    },
    "a11y": {
      "scoreUpdate": "Nu {{points}} punten, plaats {{rank}}"
    },
    "spotlight": {
      "eyebrow": "Arena",
      "daysHours": "{{days}}d {{hours}}u",
      "startsIn": "Begint over",
      "yourResult": "Je werd {{rank}}e",
      "review": "Bekijk hoe het ging"
    },
    "twoLeg": "Heen en terug",
    "noBoost": "Zonder boost",
    "share": {
      "title": "Dam-arena",
      "text": "Je bent uitgenodigd voor de arena {{nome}} op draughtsgame.com"
    },
    "detail": {
      "askPassword": "Arenawachtwoord",
      "share": "Uitnodiging delen",
      "shareCopied": "Link gekopieerd",
      "cancelArena": "Arena annuleren",
      "cancelConfirm": "De arena verdwijnt en iedereen die is ingeschreven krijgt bericht. Dit kun je niet terugdraaien."
    }
  },
  "specialEvent": {
    "eyebrow": "Speciaal evenement",
    "badge": "Speciaal",
    "organizedBy": "Georganiseerd door Draughts Game"
  },
  "legal": {
    "termsTitle": "Voorwaarden",
    "privacyTitle": "Privacy",
    "acceptTerms": "Ik accepteer de <terms>Gebruiksvoorwaarden</terms> en het <privacy>Privacybeleid</privacy>",
    "acceptTermsOnly": "Ik accepteer de <terms>Gebruiksvoorwaarden</terms>",
    "acceptPrivacyOnly": "Ik accepteer het <privacy>Privacybeleid</privacy>",
    "ageConfirm": "Ik bevestig dat ik minstens 16 jaar oud ben",
    "acceptRequired": "Je moet de Gebruiksvoorwaarden accepteren",
    "acceptTermsRequired": "Vink het vakje aan om de Gebruiksvoorwaarden te accepteren",
    "acceptPrivacyRequired": "Vink het vakje aan om het Privacybeleid te accepteren",
    "ageRequired": "Vink het vakje aan om je leeftijd te bevestigen",
    "lastUpdated": "Laatst bijgewerkt",
    "subtitle": "Jouw rechten en onze verplichtingen",
    "missingConsents_one": "Nog {{count}} vinkje hierboven",
    "missingConsents_other": "Nog {{count}} vinkjes hierboven"
  },
  "cookies": {
    "message": "We gebruiken essentiële cookies om de site te laten werken. Als je accepteert, gebruiken we ook meetinstrumenten — Umami, om te zien hoe de site wordt gebruikt, en Sentry, om fouten op te merken. Je mag weigeren: de site werkt net zo goed.",
    "acceptAll": "Alles accepteren",
    "rejectAnalytics": "Alleen essentieel"
  },
  "puzzle": {
    "toPlayAndWin": "aan zet en wint",
    "black": "Zwart",
    "white": "Wit",
    "dashboard": "Dashboard",
    "hint": "Hint",
    "hintTip": "Een hint kost je alleen de rating: deze puzzel telt niet mee voor de rating, dus je wint en verliest geen punten. Hij telt nog steeds als opgelost en behoudt je Streak.",
    "solution": "Oplossing",
    "solutionTip": "De oplossing bekijken telt als een mislukte poging: je verliest ratingpunten, maar de dag telt nog steeds mee voor je Streak.",
    "continueVsAI": "Blijf spelen tegen AI",
    "playAgain": "Opnieuw spelen",
    "back": "Terug",
    "forward": "Vooruit",
    "puzzleRating": "Puzzelrating",
    "ratingChange": "Rating",
    "newRating": "nu",
    "yourRating": "Jouw rating",
    "solutionMoves": "Oplossing",
    "moves": "zetten",
    "motifs": "Motieven",
    "motifsRevealed": "onthuld",
    "motifsHidden": "onthuld na het oplossen",
    "result": {
      "solvedEyebrow": "Opgelost",
      "failedEyebrow": "Oplossing",
      "nice": "Goed",
      "solving": "opgelost.",
      "theLine": "Dit is de",
      "line": "oplossing."
    },
    "title": "Puzzels",
    "loading": "Puzzel laden…",
    "yourTurn": "Vind de beste zet!",
    "correct": "Goed!",
    "incorrect": "Net niet",
    "solved": "Puzzel opgelost!",
    "failed": "Puzzel mislukt",
    "giveUp": "Opgeven",
    "nextPuzzle": "Volgende puzzel",
    "backToHome": "Terug naar home",
    "rating": "Rating",
    "daily": "Dagelijkse puzzel",
    "practice": "Oefenen",
    "share": "Delen",
    "solve": "Oplossen",
    "demo": {
      "badge": "Demopuzzel",
      "solvedTitle": "Knap — opgelost!",
      "trainTitle": "Elke dag trainen?",
      "registerPitch": "Maak een gratis account: elke dag een nieuwe puzzel, voor elke variant een andere.",
      "registerCta": "Gratis account maken"
    },
    "retry": "Opnieuw proberen",
    "shareTitle": "Dagelijkse puzzel",
    "shareText": "Ik heb de puzzel van vandaag opgelost — lukt het jou ook?",
    "shareCopied": "Link gekopieerd!",
    "unavailable": {
      "title": "Deze puzzel is niet beschikbaar",
      "link": "We konden de puzzel van vandaag niet openen. Misschien is er geen dagpuzzel voor deze variant, of viel de verbinding weg.",
      "session": "We konden deze puzzel niet starten. Controleer je verbinding en probeer het opnieuw.",
      "home": "Naar de startpagina"
    },
    "invite": {
      "title": "De puzzel van vandaag wacht op je",
      "body": "Een vriend heeft de puzzel van vandaag met je gedeeld. Deze puzzels zijn voorbehouden aan geregistreerde spelers — maak een gratis account aan of log in om het bord te ontgrendelen.",
      "locked": "Voorbeeld vergrendeld",
      "tryDemo": "Probeer ondertussen de demopuzzel",
      "moves_one": "{{count}} zet",
      "moves_other": "{{count}} zetten"
    },
    "guest": {
      "locked": "Daily puzzles zijn voor geregistreerde spelers. Log in of maak gratis een account aan om ze te spelen."
    },
    "networkError": "Netwerkprobleem: de zet is niet vastgelegd. Probeer opnieuw."
  },
  "dashboard": {
    "hero": {
      "welcome": "Welkom terug",
      "settings": "Instellingen",
      "ctaPlayNow": "Nu spelen",
      "ctaVsComputer": "Speel tegen AI",
      "moreVariants": "Meer varianten ({{count}})",
      "logoutConfirmTitle": "Uitloggen?",
      "logoutConfirmBody": "Je wordt op dit apparaat uitgelogd.",
      "ctaDailyPuzzle": "Dagpuzzels",
      "themeDark": "Schakel naar donker thema",
      "themeLight": "Schakel naar licht thema",
      "ratingDeltaUp": "{{points}} punten omhoog in de afgelopen 7 dagen",
      "ratingDeltaDown": "{{points}} punten omlaag in de afgelopen 7 dagen"
    },
    "notif": {
      "challengedYou": "<b>{{name}}</b> ({{rating}}) heeft je uitgedaagd voor <b>{{timeControl}}</b> · {{variant}}",
      "challengedYouNoRating": "<b>{{name}}</b> heeft je uitgedaagd voor <b>{{timeControl}}</b> · {{variant}}",
      "accept": "Accepteren",
      "decline": "Afwijzen"
    },
    "streak": {
      "daysInRow_one": "{{count}} dag op rij",
      "daysInRow_other": "{{count}} dagen op rij",
      "unitLabel_one": "dag op rij",
      "unitLabel_other": "dagen op rij",
      "record": "Record om te verbreken: <b>{{count}} dagen</b>",
      "recordTying": "Record geëvenaard: <b>{{count}} dagen</b>",
      "empty": "Begin vandaag",
      "solvePuzzle": "Los een puzzel op",
      "doneToday": "Klaar voor vandaag 🔥",
      "keepHint": "Speel of los een puzzel op om je streak te behouden.",
      "last7DaysLabel": "Activiteit van de laatste 7 dagen"
    },
    "dailyGoal": {
      "title": "Dagelijks doel",
      "label": "Partijen",
      "remaining_one": "<b>Nog één</b> om het doel te halen",
      "remaining_other": "<b>Nog {{count}}</b> om het doel te halen",
      "done": "Doel bereikt",
      "targetLabel": "Partijen per dag",
      "editGoal": "Doel aanpassen"
    },
    "activity": {
      "title": "Activiteit",
      "last3Months": "Laatste 3 maanden",
      "centerGames": "partijen",
      "statsGames_one": "{{count}} partij",
      "statsGames_other": "{{count}} partijen",
      "statsActiveDays_one": "{{count}} actieve dag",
      "statsActiveDays_other": "{{count}} actieve dagen",
      "statsPerDay": "{{value}} partijen/dag",
      "empty": "Je partijen verschijnen hier",
      "statsTotalTime": "{{value}} totaal",
      "tooltipToday": "Vandaag",
      "tooltipYesterday": "Gisteren",
      "legendBucket0": "0",
      "legendBucket1": "1-2",
      "legendBucket2": "3-5",
      "legendBucket3": "6-9",
      "legendBucket4": "10+",
      "duration": {
        "zero": "0 min",
        "minutes_one": "{{count}} min",
        "minutes_other": "{{count}} min",
        "hours_one": "{{count}}u",
        "hours_other": "{{count}}u",
        "hoursMinutes": "{{hours}}u {{minutes}}m"
      },
      "dayMon": "Ma",
      "dayThu": "Do",
      "daySat": "Za",
      "dayTue": "Di",
      "dayWed": "Wo",
      "dayFri": "Vr",
      "daySun": "Zo"
    },
    "recentGames": {
      "title": "Recente partijen",
      "viewAll": "Alles in profiel →",
      "replay": "Herhalen",
      "empty": "Nog geen partijen"
    },
    "upcomingTournaments": {
      "title": "Actieve toernooien",
      "viewAll": "Alle →",
      "viewAllAria": "Bekijk alle toernooien",
      "empty": "Geen toernooien gepland"
    },
    "liveEvent": {
      "emptyTitle": "Toernooien & Arena's",
      "empty": "Geen live evenementen",
      "nextAt": "Volgende Daily start om {{time}}",
      "minutesLeft_one": "Eindigt over {{count}} minuut",
      "minutesLeft_other": "Eindigt over {{count}} minuten",
      "participants_one": "{{count}} speler",
      "participants_other": "{{count}} spelers"
    },
    "puzzle": {
      "titleWhiteToMove": "Wit aan zet\nen wint",
      "titleBlackToMove": "Zwart aan zet\nen wint",
      "meta": "Vind de beste reeks",
      "cta": "Oplossen →",
      "viewAll": "Alle →",
      "tag": {
        "tactic": "Tactiek"
      },
      "solvedNext": "Opgelost ✓ · Kom morgen terug voor de volgende",
      "tryInternational": "Probeer een International-puzzel →",
      "overlayTitle": "Dagpuzzels"
    },
    "avvisoDati": {
      "offline": "Je lijkt offline — je gegevens zijn niet geladen.",
      "server": "Je gegevens konden niet worden geladen.",
      "inCorso": "Opnieuw…",
      "ricarica": "Herladen"
    },
    "installCard": {
      "eyebrow": "App",
      "title": "Installeer Draughts Game",
      "benefit": "Zet hem op je beginscherm: hij opent schermvullend, start sneller en staat naast je andere apps.",
      "howTo": "Hoe werkt dat?",
      "choose": "Kies je apparaat:",
      "os": {
        "android": "Android",
        "ios": "iPhone of iPad",
        "desktop": "Computer"
      }
    }
  },
  "pwa": {
    "openInAppText": "Je zit in de browser van WhatsApp. Open deze link daarbuiten om de app volledig te gebruiken.",
    "openInAppCta": "Openen in de app",
    "openInBrowserText": "Je zit in de browser van WhatsApp. Open deze link in Safari voor de volledige app.",
    "iosHint": "Tik rechtsonder op ••• en dan op “Openen in Safari”.",
    "installText": "Installeer Draughts Game en speel vanaf je beginscherm.",
    "installCta": "App installeren",
    "copyLink": "Link kopiëren",
    "linkCopied": "Link gekopieerd!",
    "dismiss": "Sluiten"
  },
  "seo": {
    "breadcrumbHome": "Home",
    "landing": {
      "title": "Draughts Game — gratis online dammen",
      "description": "Gratis online dammen: internationaal, Italiaans, Turks, Fries en nog 20 varianten. Realtime multiplayer, partijen voor je rating, toernooien, computertegenstanders en elke dag een nieuw probleem."
    },
    "faq": {
      "title": "Veelgestelde vragen — online dammen",
      "description": "Antwoorden over accounts, rating, toernooien, de app installeren en online dammen, plus een rechtstreeks kanaal voor meldingen en suggesties."
    },
    "terms": {
      "title": "Gebruiksvoorwaarden — Draughts Game",
      "description": "De voorwaarden voor het gebruik van Draughts Game: accounts, eerlijk spel, rating, inhoud en de afspraken waar beide partijen zich aan houden."
    },
    "privacy": {
      "title": "Privacybeleid — Draughts Game",
      "description": "Welke gegevens Draughts Game verzamelt, waarom, hoe lang ze bewaard blijven en welke rechten je erover hebt volgens de AVG."
    }
  }
}
